import React, { useCallback, useMemo, useRef, useState, useEffect } from "react";
import excelIcon from '../../../assets/images/excel.png';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import LoaderComponent from "../../../libraries/loader/loader";
import { getvendorcode, getBalanceFromServer,updatedonutvalue,updateclosurestatusvalue,Fetcherpdata_1,Fetchexecutequery,Fetchbankdata_1,Fetchbankinvoicedetails1,Fetchbankdata,Fetchexternaldetails, getProcessingLayerDataFromServer, getProcessingLayerDataWithStatusFromServer, getUpdateMatchRecordsFromServer, getUpdateUnMatchRecordsFromServer, getUpdateDuplicateRecordsFromServer, getUpdateContraRecordsFromServer, getProcessingLayerDataReturnFromServer, getUpdateGlBalFromServer, getUpdateBankBalFromServer, Fetchbankinvoicedetails,Fetcherpdata, Fetchmatchedutrdata, Fetchmatchedutrdata1, updatestatusvalue, allocateupdatestatusvalue, fetchmonthwisedata1, getdonutseriesdata, getkpidatarecon, getpaymenthistory, getstatustypeslist, getremarksdata, fetchmonthwisedatanew, getpaymenthistorynew,Fetchbalupdationquery, getdataforcardsrecon } from '../../../services/demo/brs/brsService1';
import axios from "axios";
import ReactApexChart from "react-apexcharts";
import DualBarGraph from './dual_bar_graph';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
// import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faFileLines, faStreetView } from '@fortawesome/free-solid-svg-icons';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import Select from "react-select";
import Modal from 'react-bootstrap/Modal';
import { Icon, Input, Button, Dropdown, Grid, Card, Popup, Segment, Tab, Table, Menu, Form, TextArea, Label, Header, Checkbox } from 'semantic-ui-react';
import RenderGrid from './grid';
import "./reconSummary.css";

function ReconSummary() {
  const [loaderOpen, setLoaderOpen] = useState(false);
  const amounttoleranceValues = [0,1, 2, 3, 4, 5, 10, 100, 200, 500, 1000];
  const datetoleranceValues = [0,1, 2, 3, 4, 5,6,7,8,9,10,14,21,28];
  const [bankquery , setBankquery] = useState('');
  const [erpquery , setERPquery] = useState('');
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [link, setLink] = useState();
  const [options, setOptions] = useState([]);
  const [accnooptions, setaccnoOptions] = useState([]);
  const [selectedaccno, setAccountno] = useState('');
  const [bankoptions, setBankoptions] = useState([]);
  const [clientids, setclientids] = useState([]);
  const [clientids1, setclientids1] = useState([]);
  const [selectedBank, setSelectedBank] = useState('');
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedOption1, setSelectedOption1] = useState('');
  const [layerId, setLayerId] = useState('');
  const [erpBalance, setErpBalance] = useState(0.00);
  const [bankBalance, setBankBalance] = useState(0.00);
  const [chartHidden, setChartHidden] = useState(true);
  const [doughnutLabel, setDoughnutLabel] = useState([]);
  const [doughnutdata, setDoughnutData] = useState([]);
  const [doughnutLabel2, setDoughnutLabel2] = useState([]);
  const [doughnutdata2, setDoughnutData2] = useState([]);
  const [label, setLabel] = useState('');
  const [unMatchedHidden, setUnMatchedHidden] = useState(false);
  const [searchHidden, setSearchHidden] = useState(true);
  const [intGridData, setIntGridData] = useState([]);
  const [extGridData, setExtGridData] = useState([]);
  const [filteredextTableData, setFilteredextTableData] = useState([]); // Filtered data
  const [extselectedDate, extsetSelectedDate] = useState(null);       // Selected date for filtering
  const [extselecteddebitAmount, extsetSelecteddebitAmount] = useState(null);   // Selected amount for filtering
  const [extselectedcreditAmount, extsetSelectedcreditAmount] = useState(null);   // Selected amount for filtering
  const [filteredintTableData, setFilteredintTableData] = useState([]); // Filtered data
  const [intselectedDate, intsetSelectedDate] = useState(null);       // Selected date for filtering
  const [intselecteddebitAmount, intsetSelecteddebitAmount] = useState(null);   // Selected amount for filtering
  const [intselectedcreditAmount, intsetSelectedcreditAmount] = useState(null);   // Selected amount for filtering
  const headers = ['0-30 Days','31-60 Days','61-90 Days','90+ Days']
  const [toleranceAmount, setToleranceAmount] = useState(0); // Amount tolerance
  const [dateTolerance, setDateTolerance] = useState(0); 
  const [intDebit, setIntDebit] = useState(0.00);
  const [intCredit, setIntCredit] = useState(0.00);
  const [extDebit, setExtDebit] = useState(0.00);
  const [extCredit, setExtCredit] = useState(0.00);
  const [intDate, setIntDate] = useState(undefined);
  const [extDate, setExtDate] = useState(undefined);
  const [amountTolerance, setAmountTolerance] = useState(0.00);
  const [openGridHidden, setOpenGridHidden] = useState(true);
  const [openIntGridData, setOpenIntGridData] = useState([]);
  const [openExtGridData, setOpenExtGridData] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const agIntGridRef = useRef(null);
  const agExtGridRef = useRef(null);
  const intMatchingRows = [];
  const extMatchingRows = [];
  const [internalAmount, setInternalAmount] = useState(0.00);
  const [externalAmount, setExternalAmount] = useState(0.00);
  const [matchHidden, setMatchHidden] = useState(true);
  const [contraHidden, setContraHidden] = useState(true);
  const [duplicateHidden, setDuplicateHidden] = useState(true);
  const [unMatchHidden, setUnMatchHidden] = useState(false);
  const [intId, setIntId] = useState('');
  const [bankclosure, setBankclosure] = useState('');
  const [erpclosure, setErpclosure] = useState('');
  const [annexure1Data, setAnnexure1Data] = useState([]);
  const [annexure2Data, setAnnexure2Data] = useState([]);
  const [annexure3Data, setAnnexure3Data] = useState([]);
  const [annexure4Data, setAnnexure4Data] = useState([]);
  const [doughnutLabel4, setDoughnutLabel4] = useState([]);
  const [doughnutdata4, setDoughnutData4] = useState([]);
  const [selectedEntity, setSelectedEntity] = useState([]);
  const [monthclosure, setMonthclosure] = useState('')
  const [intName, setIntName] = useState("");
  const [extName, setExtName] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [unMatchStyles, setUnMatchStyles] = useState(undefined);
  const [selectCheckBox, setSelectCheckBox] = useState(undefined);
  const [searchText, setSearchText] = useState('');
  const [hideLabels, setHideLabels] = useState(false);
  const chartRef = useRef(null);

  const [arcolumnnames, setarcolumnnames] = useState([]);
  const [bankcolumnnames, setbankcolumnnames] = useState([]);

  const [modelcolumnnames, setmodelcolumnnames] = useState([]);
  const [modelcolumnnames1, setmodelcolumnnames1] = useState([]);

  const [show3, setShow3] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show5, setShow5] = useState(false);
  const [show6, setShow6] = useState(false);
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1; // getMonth() returns 0-based month, so add 1
  const currentYear = currentDate.getFullYear();
  // Format the selectedDate in 'YYYY-MM' format
  const formattedDate = `${currentYear}-${String(currentMonth).padStart(2, '0')}`;
  const [selectedDate, setSelectedDate] = useState(formattedDate);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedYear, setSelectedYear] = useState(currentYear);

  const [matchedData, setMatchedData] = useState({});
  const [unmatcheddata, setunmatcheddata] = useState({});
  const [alldata, setalldata] = useState({});
  const [data1, seterpData1] = useState([]);
  const [data2, setbankData2] = useState([]);
  const [lastDate, setlastDate] = useState('');
  const [lastDate1, setlastDate1] = useState('');

  const handleDateChange = date => {
    console.log("selectedOption",selectedOption);
    setSelectedDate(date);
    fetchdonutchartdata(date,selectedOption);
    fetchdonutchartdata2(date,selectedOption);
    getbalanceinfo(selectedOption.value,date);
    fetchmonthwisedata(selectedOption);
    fetchpaymenthistory(selectedOption.label, 'Day');
    let dateParts = date.split('-'); // Split the date by the hyphen
    let selectedMonth12 = parseInt(dateParts[1]); // Extract the month (convert to integer)
    let selectedYear12 = parseInt(dateParts[0]);
    console.log("date change",date,selectedYear12,selectedMonth12);
    let lastDate12 = getPreviousMonthLastDate(selectedYear12,selectedMonth12);
    setlastDate1(lastDate12);
    getVarianceinfo1(selectedMonth12,selectedYear12,selectedOption);
    // You can perform any additional logic here when the date is selected
  };

const getLastDateOfMonth = (year, month) => {
  const date = new Date(year, month, 0);  // month is 0-indexed, so 0 represents January, 1 represents February, etc.
  const day = String(date.getDate()).padStart(2, '0');
  const monthAbbr = date.toLocaleString('default', { month: 'short' }); // Get the month abbreviation (e.g., 'Aug')
  const formattedDate = `${day}-${monthAbbr}-${year}`;
  return formattedDate;
};

function getPreviousMonthLastDate(year, month) {
  let previousMonth = month - 1;
  let previousYear = year;
  if (previousMonth < 0) {
    previousMonth = 11;
    previousYear = year - 1;
  }
  return getLastDateOfMonth(previousYear, previousMonth);
}

  const [selectedLabel, setSelectedLabel] = useState('');

  const [finalinternaldata, setfinalinternaldata] = useState([]);
  const [finalexternaldata, setfinalexternaldata] = useState([]);
  const [ismatched, setismatched] = useState({});


  const [customer_advice_location, setcustomer_advice_location] = useState('');

  const [erpbalance, seterpbalance] = useState('');
  const [bankbalance, setbankbalance] = useState('');
  const [difference, setdifference] = useState('');

  const [optionslist, setOptionslist] = useState([]);

  const [matchidslist, setmatchidslist] = useState([]);


  const [remarkscol, setremarkscol] = useState([]);
  const [remarksdata, setremarksdata] = useState([]);

  const [remarkscol1, setremarkscol1] = useState([]);
  const [remarksdata1, setremarksdata1] = useState([]);
  const [selectedOption99, setSelectedOption99] = useState('');
  const [dropdown1, setdropdown1] = useState({ value: "Day", label: "Day" });
  const [dropdown2, setdropdown2] = useState({});
  const [userid, setuserid] = useState(userCredentials["user_id"]);
  const [barwidth, setbarwidth] = useState('40%');
  const [barwidth1, setbarwidth1] = useState('40%');


  const chartData1 = {
    labels: doughnutLabel,
    series: doughnutdata,
  };

  const chartData3 = {
    labels: doughnutLabel2,
    series: doughnutdata2,
  };


  const internaltotal1 = React.useMemo(() => {
    if (openIntGridData?.length > 0) {
      // Get the column names from the first row of the JSON data
      let total = 0.0;
      openIntGridData.forEach((row) => {
        const Amount = parseFloat((row['debit amt']).replace(/,/g, '')); // Convert the amount to a number
	const Amount2 = parseFloat((row['credit amt']).replace(/,/g, ''));
        total += Amount-Amount2 ;
      })
      const usFormatter = new Intl.NumberFormat("en-IN");
      const formattedTotal = usFormatter.format(total);
      setInternalAmount(formattedTotal);
      return [];
    }
    return [];
  }, [openIntGridData]);

const externaltotal1 = React.useMemo(() => {
    if (openExtGridData?.length > 0) {
      // Get the column names from the first row of the JSON data
      let total = 0.0;
      const cr = 'cr';
      const dr = 'dr';
      let withdrawalAmtStr, depositAmtStr; // Declare the variables outside of the if blocks 
      openExtGridData.forEach((row) => {
        
        const Amount3 = parseFloat((row['Credit']).replace(/,/g, '')); // Convert the amount to a number
	const Amount4 = parseFloat((row['Debit']).replace(/,/g, ''));
        total += Amount3-Amount4 ;
      });
      const usFormatter = new Intl.NumberFormat("en-IN");
      const formattedTotal = usFormatter.format(total);
      setExternalAmount(formattedTotal);
      return [];
    }
    return [];
}, [openExtGridData]);

const legendColors = {
    "Match": "#000055",
    "Unmatched": "#FF220C",
    "Group Match": "#C88227",
    "Possible Match": "#37593A",
    "Contra": "#00FF00"
};
const getLegendColors = (options) => {
    return options.map(label => legendColors[label] || "#00cccc"); // Default color if not found
};


  const DynamicDonutChart = ({ options, series, onClick }) => {
    const handleDataPointSelection = (event, chartContext, config) => {
      console.log('Data:', chartData.series, chartData.options.labels);
      console.log('Event:', event);
      if (config && config.w && config.w.config && config.w.config.labels && config.dataPointIndex !== undefined) {
        const selectedLabel = config.w.config.labels[config.dataPointIndex];
        if (selectedLabel) {
          console.log('selectedLabel', selectedLabel);
          onClick(selectedLabel);
        }
      }
    };

    const chartData = {
      series: series,
      options: {
        labels: options,
        colors: getLegendColors(options),
        legend: {
        show: true,  // Make sure legend is visible
        position: 'bottom', // Position of the legend, can be 'top', 'right', 'bottom', 'left'
        horizontalAlign: 'center', // Align legend items horizontally ('center', 'left', 'right')
        fontSize: '14px', // Increase the font size of the legend text
        markers: {
          width: 20, // Increase the size of the color marker box
          height: 20, // Increase the height of the color marker box
          radius: 3 // Optional: adjust radius for rounded corners
        },
        itemMargin: {
          horizontal: 10, // Increase horizontal spacing between legend items
          vertical: 5 // Increase vertical spacing between legend items
        },
        onItemClick: {
          toggleDataSeries: function(seriesIndex) {
            const chart = this.chart;
            if (chart.series[seriesIndex].visible) {
              chart.hideSeries(seriesIndex);
            } else {
              chart.showSeries(seriesIndex);
            }
          }
        },
      },
        chart: {
          width: 28,
          height: 100,
          type: 'donut'
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270
          },
        },
        dataLabels: {
          enabled: false
        },
        fill: {
          type: 'gradient',
        },
        
        title: {
          text: ''
        },
        chart: {
          events: {
            dataPointSelection: handleDataPointSelection
          }
        }
      },
    };

    useEffect(() => {
      if (chartData.series.length > 0) {
        // Reinitialize the chart when data is available
        chartData.options.chart.events = {
          dataPointSelection: handleDataPointSelection
        };
      }
    }, [chartData.series]);  

    return (
      <div id="chart-container">
        <ReactApexChart options={chartData.options} series={chartData.series} type="donut" />
      </div>
    );
  };


const handledatetoleranceChange = (event) => {
    setDateTolerance(Number(event.target.value));
  };

const handleamounttoleranceChange = (event) => {
    setToleranceAmount(Number(event.target.value));
  };

const updatestatuscolumn = (selectedLabel) => {
  const intern_id_1 = openIntGridData.map(item => item.primary_id);
  const intern_id = `${intern_id_1.join(', ')}`;
  const extern_id_1 = openExtGridData.map(item => item.primary_id);
  const extern_id = `${extern_id_1.join(', ')}`;
  const internCloseStatuses = openIntGridData.map(item => item.close_status);
  const externCloseStatuses = openExtGridData.map(item => item.close_status);

  if (internCloseStatuses.includes(1) || externCloseStatuses.includes(1)) {
    alert("Records have been closed!");
    return; // Stop execution
  }

  if (internCloseStatuses.includes(2) || externCloseStatuses.includes(2)) {
    alert("Records have been frozen!");
    return; // Stop execution
  }

  const internData = openIntGridData;
  const externData = openExtGridData;

  const internCount = internData.length;
  const externCount = externData.length;


 const label = selectedLabel?.value;
  console.log("internCount ",internCount,externCount,label)
  // Both sides have records     
  if (label === 'Match') {
    if (internCount === 1 && externCount === 1) {
      // valid
    } else {
      alert("Match requires exactly one record on each side. Please choose 'Group Match' instead.");
      return;
    }
  }

  // Group Match
  if (label === 'Group Match') {
    if (internCount > 0 && externCount > 0 && (internCount > 1 || externCount > 1)) {
      // valid
    } else {
      alert("Group Match requires multiple records on at least one side. Please choose 'Match' if only one record per side or 'Contra' if records are available on one side only");
      return;
    }
  }

  // Contra
  if (label === 'Contra') {
    if (
      (internCount === 2 && externCount === 0) ||
      (externCount === 2 && internCount === 0)
    ) {
      // valid
    } else if (
      (internCount > 2 && externCount === 0) ||
      (externCount > 2 && internCount === 0)
    ){
      alert("Contra requires exactly two records on one side. Please Choose 'Group Contra'");
      return;
    } else {
      alert("Contra requires exactly two records on one side and none on the other. Please Choose 'Group Match' or 'Match'");
      return;
    }

  }

  // Group Contra
  if (label === 'Group Contra') {
    if (
      (internCount > 2 && externCount === 0) ||
      (externCount > 2 && internCount === 0)
    ) {
      // valid
    } else {
      alert("Group Contra requires more than two records on any one side and none on the other.");
      return;
    }
  }
  let payload = {
    "schema_name": "txbrs",
    "extern_table": "bank",
    "intern_table": "erp",
    "set_column": { "match_status": selectedLabel.value },
    'where': [{ 'primary_id': intern_id }],
    'where1': [{ 'primary_id': extern_id }],
  };

  var getProcessingLayerDataWithStatus = updatestatusvalue();

  return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
    .then(response => {
      console.log("Processing Layer Data With Status!!!", response);
      if (response.data.Status === "success") {
        alert("Records updated successfully!");
      } else {
        alert("Error updating records: " + response.data.message);
      }
    })
    .catch(error => {
      console.log("Error in Processing Layer Data With Status!!!", error);
      alert("An error occurred while updating records.");
    });
};

  function getVarianceinfo1(month,year,glcode) {
    let query =  `WITH FilteredERP AS (
    SELECT 
        *,STR_TO_DATE(\`gl date\`, '%d-%b-%Y') AS gl_date_converted
    FROM txbrs.erp where glcd ='${glcode.value}' and division = '${selectedBank.value}' and match_status='Unmatched'
),
FilteredBank AS (
    SELECT 
        *,STR_TO_DATE(\`entry date\`, '%d-%b-%Y') AS entry_date_converted
    FROM txbrs.bank where gl_code ='${glcode.value}' and division = '${selectedBank.value}' and match_status='Unmatched'
),
MatchingContraERP AS (
    SELECT 
        match_id, 
        primary_id 
    FROM 
        txbrs.erp
    WHERE 
        match_status = 'Contra' and division = '${selectedBank.value}' and glcd ='${glcode.value}'
),
MatchingContraBank AS (
    SELECT 
        match_id, 
        primary_id
    FROM 
        txbrs.bank
    WHERE 
        match_status = 'Contra' and division = '${selectedBank.value}' and gl_code ='${glcode.value}'
)
SELECT 
    annexure_type,
    age_group,
    sum(total_value) as total_value,
    COUNT(*) AS count
FROM (
    SELECT 
        CASE 
            WHEN a.\`credit amt\` = 0 THEN 'annexure 2'
            WHEN a.\`debit amt\` = 0 THEN 'annexure 3'
        END AS annexure_type,SUM(a.\`credit amt\` + a.\`debit amt\`) as total_value,a.glcd as gl_code,
        CASE
            WHEN DATEDIFF(CURDATE(), a.gl_date_converted) <= 30 THEN '0-30'
            WHEN DATEDIFF(CURDATE(), a.gl_date_converted) BETWEEN 31 AND 60 THEN '31-60'
            WHEN DATEDIFF(CURDATE(), a.gl_date_converted) BETWEEN 61 AND 90 THEN '61-90'
            ELSE '90+'
        END AS age_group
    FROM 
        FilteredERP a
    LEFT JOIN 
        FilteredBank e ON e.match_id = a.match_id
    LEFT JOIN 
        MatchingContraERP mc ON a.match_id = mc.match_id AND a.primary_id != mc.primary_id
    WHERE 
        (
            (a.match_status = 'Unmatched' AND MONTH(a.gl_date_converted) <= '${month}' 
                AND YEAR(a.gl_date_converted) <= '${year}')
            OR 
            (a.match_id IS NOT NULL AND a.match_status IN ('Match') 
                AND MONTH(a.gl_date_converted) <= '${month}' 
                AND YEAR(a.gl_date_converted) <= '${year}' 
                AND e.match_id IS NULL)
            OR 
            (a.match_id IS NOT NULL AND a.match_status IN ('Group Match', 'group unmatched', 'Groupmatch') 
                AND e.match_id IS NULL)
            OR 
            (a.match_id IS NOT NULL AND a.match_status = 'Contra' 
                AND MONTH(a.gl_date_converted) <= '${month}' 
                AND YEAR(a.gl_date_converted) <= '${year}' 
                AND mc.match_id IS NULL)
        ) group by  annexure_type,age_group,gl_code
    
    UNION ALL
    
    SELECT 
        CASE
            WHEN a.Credit = 0 THEN 'annexure 1'
            WHEN a.Debit = 0 THEN 'annexure 4'
        END AS annexure_type,SUM(a.Credit + a.Debit) as total_value,a.gl_code as gl_code,
        CASE
            WHEN DATEDIFF(CURDATE(), a.entry_date_converted) <= 30 THEN '0-30'
            WHEN DATEDIFF(CURDATE(), a.entry_date_converted) BETWEEN 31 AND 60 THEN '31-60'
            WHEN DATEDIFF(CURDATE(), a.entry_date_converted) BETWEEN 61 AND 90 THEN '61-90'
            ELSE '90+'
        END AS age_group
    FROM 
        FilteredBank a
    LEFT JOIN 
        FilteredERP e ON e.match_id = a.match_id
    LEFT JOIN 
        MatchingContraBank mc ON a.match_id = mc.match_id AND a.primary_id != mc.primary_id
    WHERE 
        
            (a.match_status = 'Unmatched' AND MONTH(a.entry_date_converted) <= '${month}'
                AND YEAR(a.entry_date_converted) <= '${year}')
            OR 
            (a.match_id IS NOT NULL AND a.match_status IN ('Match') 
                AND MONTH(a.entry_date_converted) <= '${month}'
                AND YEAR(a.entry_date_converted) <= '${year}' 
                AND e.match_id IS NULL)
            OR 
            (a.match_id IS NOT NULL AND a.match_status IN ('Group Match', 'group unmatched', 'Groupmatch') 
                AND e.match_id IS NULL)
            OR 
            (a.match_id IS NOT NULL AND a.match_status = 'Contra'
                AND MONTH(a.entry_date_converted) <= '${month}' 
                AND YEAR(a.entry_date_converted) <= '${year}' 
                AND mc.match_id IS NULL)
          group by  annexure_type,age_group,gl_code

) AS CombinedData

group by annexure_type, 
    age_group
ORDER BY 
    annexure_type, 
    age_group
;`


    let payload = {
      query : query
    }

    var getProcessingLayerDataWithStatus = Fetchexecutequery();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status annexure aging!!!", response)
          let data = response["data"];
          const groupedData = data.reduce((acc, item) => {
            if (!acc[item.annexure_type]) {
              acc[item.annexure_type] = {};
            }
            acc[item.annexure_type][item.age_group] = item.total_value;
            return acc;
          }, {});

            // Step 2: Define the age groups for the x-axis
            const categories = ["0-30", "31-60", "61-90", "90+"];  // Age groups

            // Step 3: Extract and set the labels and counts for the doughnut chart
            // Assuming you want the age groups for the doughnut chart
            const status = categories;  // The age groups are the status (categories)
            const countForDoughnut = categories.map(ageGroup => {
            // Sum the counts for each age group across all annexures
            return data.filter(item => item.age_group === ageGroup).reduce((sum, item) => sum + item.total_value, 0);
          });

          // Set the doughnut labels and data
          const annexure1Data = categories.map(ageGroup => groupedData["annexure 1"] && groupedData["annexure 1"][ageGroup] !== undefined ? groupedData["annexure 1"][ageGroup] : 0);
          const annexure2Data = categories.map(ageGroup => groupedData["annexure 2"] && groupedData["annexure 2"][ageGroup] !== undefined? groupedData["annexure 2"][ageGroup] : 0);
          const annexure3Data = categories.map(ageGroup => groupedData["annexure 3"] && groupedData["annexure 3"][ageGroup] !== undefined? groupedData["annexure 3"][ageGroup] : 0);
          const annexure4Data = categories.map(ageGroup => groupedData["annexure 4"] && groupedData["annexure 4"][ageGroup] !== undefined? groupedData["annexure 4"][ageGroup] : 0);
          setDoughnutLabel4(status);
          setDoughnutData4([annexure1Data, annexure2Data, annexure3Data, annexure4Data]);
          console.log("ageingdata",annexure1Data,annexure2Data)
setAnnexure1Data(annexure1Data);
setAnnexure2Data(annexure2Data);
setAnnexure3Data(annexure3Data);
setAnnexure4Data(annexure4Data);

        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }



  const updatestatuscolumn1 = (selectedLabel) => {

    const extern_id_1 = openExtGridData.map(item => item.primary_id);
    const extern_id = `(${extern_id_1.join(', ')})`;

    let payload = {

      "schema_name" : "txbrs",
      "table" : selectedOption.value,
      "set_column" : {"status" : selectedLabel.value},
      'where': [{ 'primary_id': extern_id }],
      
    }
    var getProcessingLayerDataWithStatus = updatestatusvalue();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status!!!", response)

        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );

  }

  const ClickSaveButton = () => {
    updatestatuscolumn(ismatched);    
  }


  const [selectedval, setselectedval] = useState('');

  
  const handleSelectionmatched = (event) => {
    setismatched(event);
    setselectedval(event.label)
  }


  const handleChartClick = (label) => {
    
    let date1 = new Date(selectedDate+ "-01");  // Add a day to make it a valid date
    // Get the month (in numeric format) and the year
    let month = date1.getMonth() + 1;  // getMonth() returns 0-based index (0 = January)
    let year = date1.getFullYear();
    if(label == 'all'){
      Fetchbankinfo_(label,month,year)
      Fetchbankinfo_1(label,month,year)
    } else if(label == 'Unmatched'){
      Fetchbankinfo2(label,lastDate)
      Fetchbankinfo3(label,lastDate)
    } else{
      Fetchbankinfo(label,month,year)
      Fetchbankinfo1(label,month,year)
    }
    //setUnMatchHidden(false);
    setUnMatchedHidden(false);
  };

  const handleChartClick1 = (label) => {
    
    let date1 = new Date(selectedDate+ "-01");  // Add a day to make it a valid date
    // Get the month (in numeric format) and the year
    let month = date1.getMonth();  // getMonth() returns 0-based index (0 = January)
    let year = date1.getFullYear();

    if (month === 0) {
        // If January, move to December of the previous year
        month = 12; // December
        year -= 1; // Previous year
    }else {
        // Otherwise, move to the previous month
        month = month;
    }

    if(label == 'all'){
      Fetchbankinfo_(label,month,year)
      Fetchbankinfo_1(label,month,year)
    }else if(label == 'Unmatched'){
      Fetchbankinfo2(label,lastDate1)
      Fetchbankinfo3(label,lastDate1)
    }else {
      Fetchbankinfo(label,month,year)
      Fetchbankinfo1(label,month,year)
    }
    //setUnMatchHidden(false);
    setUnMatchedHidden(false);
  };


  const intColumnDefs3 = React.useMemo(() => {
    if (modelcolumnnames1?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(modelcolumnnames1[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs = [

        ...keys.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          width: 100
        })),
      ];
      setmodelcolumnnames(intColumnDefs);
      // console.log('intColumnDefs', intColumnDefs);
      return intColumnDefs;
    }
    return [];
  }, [modelcolumnnames1]);

  function getgridClickedDataReturn(selectedLabel) {
    let payload = {
 	query: `select * from txbrs.bank where gl_code=${selectedOption.value} and division = '${selectedBank.value}' and Match_id = '${selectedLabel}';`
	
    }
    var getProcessingLayerDataWithStatus = Fetchexecutequery();
    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status!!!", response)
          let data = response["data"];
          console.log('data', data);
          setmodelcolumnnames1((prevState) => [
            ...prevState,
            ...data]);

        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );

  }

const intColumnDefs1 = React.useMemo(() => {
  if (intGridData?.length > 0) {
    // Get the column names from the first row of the JSON data
    const keys = Object.keys(intGridData[0]);

    // Create column definitions with the checkbox as the first column
    const intColumnDefs = [
      {
        headerCheckboxSelection: true, // Add this line for the checkbox selection
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true, // Add this line for the checkbox selection
        width: 20
      },
      ...keys.map((key) => {
        // Determine if the column is 'credit' or 'debit' for right alignment
        const isCreditOrDebit = key.toLowerCase() === 'credit amt' || key.toLowerCase() === 'debit amt';
        
        return {
          headerName: key.replace(/_/g, ' '),
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          width: 130,
          // If it's a credit or debit column, apply right alignment
          cellStyle: isCreditOrDebit ? { textAlign: 'right' } : {}
        };
      }),
    ];

    setarcolumnnames(intColumnDefs);
    console.log('intColumnDefs', intColumnDefs);
    return intColumnDefs;
  }
  return [];
}, [intGridData]);

const intColumnDefs10 = React.useMemo(() => {
  if (extGridData?.length > 0) {
    // Get the column names from the first row of the JSON data
    const keys = Object.keys(extGridData[0]);

    // Create column definitions with the checkbox as the first column
    const intColumnDefs1 = [
      {
        headerCheckboxSelection: true, // Add this line for the checkbox selection
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true, // Add this line for the checkbox selection
        width: 20
      },
      ...keys.map((key) => {
        // Check if the column is 'credit' or 'debit' for right alignment
        const isCreditOrDebit = key.toLowerCase() === 'credit' || key.toLowerCase() === 'debit';
        
        return {
          headerName: key.replace(/_/g, ' '),
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          width: 130,
          // If it's a credit or debit column, apply right alignment
          cellStyle: isCreditOrDebit ? { textAlign: 'right' } : {}
        };
      }),
    ];

    setbankcolumnnames(intColumnDefs1);
    console.log('intColumnDefs', intColumnDefs1);
    return intColumnDefs1;
  }
  return [];
}, [extGridData]);


  const handleOpenModal = () => {
    setModalIsOpen(true);
  };



  const handleCloseModal = () => {
    setModalIsOpen(false);
  };


  const intColumnDefs2 = React.useMemo(() => {
    if (remarksdata1?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(remarksdata1[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs1 = [
        {
          headerCheckboxSelection: true, // Add this line for the checkbox selection
          checkboxSelection: true, // Add this line for the checkbox selection
          width: 20
        },
        ...keys.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          width: 100
        })),
      ];
      setremarkscol1(intColumnDefs1);
      console.log('intColumnDefs', intColumnDefs1);
      return intColumnDefs1;
    }
    return [];
  }, [remarksdata1]);



  const fetchmonthwisedataAll = (event) => {
    if (event) {
      let payload = {
        'client_ids': event.label,
      }

      console.log('payload---', payload, event)

      var FileUploadCredentials = fetchmonthwisedatanew();

      axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
          response => {
            console.log("Validate Credentials Response fetch month wise data new!!!", response);
            let data = response["data"];
            let data1 = data['data'];
            setremarksdata1(data1);
            setShow6(true);
          }
        )
        .catch((error) => {

          console.error("Error in POST request:", error);
        });
    }
  }


  const fetchpaymenthistoryAll = (event) => {
    if (event) {
      let payload = {
        'client_ids': event.label,
        'key': dropdown1.value
      }

      console.log('payload---', payload, event)

      var FileUploadCredentials = getpaymenthistorynew();

      axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
          response => {
            console.log("Validate Credentials Response get payment history data new!!!", response);
            let data = response["data"];
            let data1 = data['data'];
            setremarksdata1(data1);
            setShow6(true);

          }

        )
        .catch((error) => {

          console.error("Error in POST request:", error);
        });
    }
  }

  const handleBarClick = () => {
    fetchmonthwisedataAll(selectedOption1)
  };

  const handleBarClick1 = () => {
    fetchpaymenthistoryAll(selectedOption1)
  };
const allData = [
  ...annexure1Data,
  ...annexure2Data,
  ...annexure3Data,
  ...annexure4Data
];


const roundToNearest = (value,multiple) => {
  // Round value to the nearest 200,000 (or any other multiple you'd prefer)
  return Math.round(value / multiple)*multiple;
};
const minVariance1 = Math.min(...allData);
const maxVariance1 = Math.max(...allData);



const chartDatanew21 = {
  options: {
    chart: {
      type: 'line',  // Line chart type
      height: 350,  // Set the chart height
    },
    stroke: {
      curve: 'smooth', // Smooth curve for the line
      width: 3,        // Line thickness
    },
    xaxis: {
      categories: doughnutLabel4,  // Categories (e.g., months or periods)
      title: {
        text: 'Month',  // Label for x-axis
      },
    },
    yaxis: {
      title: {
        text: 'Variance',  // Label for y-axis
      },
      min: roundToNearest(minVariance1 / 100000, 1),  // Dynamically set the min value of the y-axis (rounded)
      max: roundToNearest(maxVariance1 / 100000, 1),  // Dynamically set the max value of the y-axis (rounded)
      labels: {
        formatter: function (value) {
          if (value !== undefined && value !== null) {
		let roundedValue = roundToNearest(value * 100000, 100000);  // Convert back to full value for display
                return (value).toLocaleString() + ' C';  // Display in lakhs (e.g., 134 L)
                // return roundedValue.toLocaleString();
        	// return value.toLocaleString();  // Format the value
      	  }
      return '';  // Return an empty string if the value is undefined or null

        },
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          if (val !== undefined && val !== null) {
        	return val.toLocaleString();  // Format the value
      	  }
      return '';   // Format tooltip values as currency
        },
      },
    },
    legend: {
      position: 'bottom',
      horizontalAlign: 'center',
    },
    grid: {
      borderColor: '#f1f1f1',
    },
    dataLabels: {
      enabled: false,  // Disable data labels if you don't want to display values directly on the chart
    },
    markers: {
      size: 5,  // Marker size at data points
      colors: ['#ff4560', '#00e396', '#3f51b5', '#9c27b0'],  // Custom colors for markers (one for each annexure)
    },
  },
  series: [
          { name: 'Annexure 1', data: annexure1Data.map(val => val / 100000) },  // Convert to lakhs
    { name: 'Annexure 2', data: annexure2Data.map(val => val / 100000) },  // Convert to lakhs
    { name: 'Annexure 3', data: annexure3Data.map(val => val / 100000) },  // Convert to lakhs
    { name: 'Annexure 4', data: annexure4Data.map(val => val / 100000) },
  ],
};


  const labelslist = [];
  const seriesdata = [];

  const [barlabellist, setbarlabellist] = useState([]);
  const [barserieslist, setbarserieslist] = useState([]);

  const chartData5 = {
    series: [
      {
        name: 'Series 1',
        data: barserieslist,
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 200,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          endingShape: 'rounded',
          columnWidth: barwidth1
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: barlabellist,
      },
      fill: {
        colors: ['#3B3C36'],
      },
    },
  };

  const BarChart = () => {
    const options = {
      chart: {
        type: 'bar',
      },
      xaxis: {
        categories: barlabellist,
        fill: {
          colors: ['#0a2352'],
        },
      },
    };

    const series = [
      {
        name: 'Month wise data',
        data: barserieslist,

      }

    ];

    return (
      <div>

        <ReactApexChart options={chartData5.options} series={chartData5.series} type="bar" height={255} onClick={handleBarClick} />
      </div>
    );
  };


  const [barlabellist1, setbarlabellist1] = useState([]);
  const [barserieslist1, setbarserieslist1] = useState([]);


  const chartData2 = {
    series: [
      {
        name: 'Series 1',
        data: barserieslist1,
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 300,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          endingShape: 'rounded',
          columnWidth: barwidth
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: barlabellist1,
      },
      fill: {
        colors: ['#0a2352'],
      },
    },
  };

  const BarChart1 = () => {
    const options = {
      chart: {
        type: 'bar',
      },
      xaxis: {
        categories: barlabellist1,
        fill: {
          colors: ['#0a2352'],
        },
      },
    };

    const series = [
      {
        name: 'Month wise data',
        data: barserieslist1,
      }

    ];

    return (
      <div>

        <ReactApexChart options={chartData2.options} series={chartData2.series} type="bar" height={200} onClick={handleBarClick1} />
      </div>
    );
  };

  const fetchmonthwisedata = (event) => {
    if (event) {
      let payload = {
        'client_ids': event.label,
      }

      console.log('payload---', payload, event)

      var FileUploadCredentials = fetchmonthwisedata1();

      axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
          response => {
            console.log("Validate Credentials Response fetch month wise data!!!", response);
            let data = response["data"];
            let data1 = data['data']

            const ageBuckets = data1.map(item => item.AgeBucket);
            const totalInvoiceAmounts = data1.map(item => item.TotalInvoiceAmount);
            // setDoughnutData([60, 30, 150])
            setChartHidden(false);
            setbarlabellist(ageBuckets);
            setbarserieslist(totalInvoiceAmounts);

            let arrayLength = [];
            let datesArray = ageBuckets;
            arrayLength = datesArray.length;

            if (arrayLength == 3) {
              setbarwidth1('40%')
            } else if (arrayLength == 2) {
              setbarwidth1('30%')
            } else if (arrayLength == 4) {
              setbarwidth1('45%')
            } else if (arrayLength == 5) {
              setbarwidth1('50%')
            } else {
              setbarwidth1('10%')
            }

          }

        )
        .catch((error) => {
          // setDoughnutData([60, 30, 150])
          setChartHidden(false);
          console.error("Error in POST request:", error);
        });
    }
  }


  const fetchpaymenthistory = (event, param) => {
    if (event) {
      let payload = {
        'client_ids': event,
        'key': param
      }

      console.log('payload---', payload, event)

      var FileUploadCredentials = getpaymenthistory();

      axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
          response => {
            console.log("Validate Credentials Response get payment history data!!!", response);
            let data = response["data"];

            // setDoughnutData([60,30,150])
            setChartHidden(false);
            setbarlabellist1(data['labels']);
            setbarserieslist1(data['values']);
            let arrayLength = [];
            let datesArray = data['labels'];
            arrayLength = datesArray?.length;

            if (arrayLength == 3) {
              setbarwidth('40%')
            } else if (arrayLength == 2) {
              setbarwidth('30%')
            }  else if (arrayLength == 1) {
              setbarwidth('20%')
            } else {
              setbarwidth('30%')
            }

          }

        )
        .catch((error) => {
          // setDoughnutData([60,30,150])
          setChartHidden(false);
          console.error("Error in POST request:", error);
        });
    }
  }

  const Fetchbankinfo1 = (label,month,year) => {
    let payload = {
 	query: `select \`Value Date\`,	\`Entry Date\`,	\`Transaction Type\`,	\`Transaction Reference\`, FORMAT(\`Debit\`,2) AS \`Debit\`,FORMAT(\`Credit\`,2) AS \`Credit\`,\`Narration\`,primary_id,match_status,match_id,close_status from txbrs.bank where gl_code = '${selectedOption.value}' and division = '${selectedBank.value}' and match_status = '${label}' and MONTH(STR_TO_DATE(\`entry date\`, '%d-%b-%Y')) = '${month}' and YEAR(STR_TO_DATE(\`entry date\`, '%d-%b-%Y')) = '${year}';`
	
    }
    console.log('payload---', payload)

    var FileUploadCredentials = Fetchexecutequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          let data = response["data"];
          setExtGridData(data)
        }
      )
      .catch((error) => {
        console.error("Error in POST request:", error);
      });
  }

  const Fetchbankinfo = (label,month,year) => {

    let payload = {
 	query: `select \`vou catg\`,\`doc catg\`,\`doc no\`,\`doc date\`,\`gl date\`,\`party code\`,\`party name\`, FORMAT(\`debit amt\`,2) AS \`debit amt\`,FORMAT(\`credit amt\`,2) AS \`credit amt\`,\`narration\`,\`ref1\`,match_status,match_id,primary_id,close_status from txbrs.erp where glcd = ${selectedOption.value} and division = '${selectedBank.value}' and match_status = '${label}'  and MONTH(STR_TO_DATE(\`gl date\`, '%d-%b-%Y')) = '${month}' and YEAR(STR_TO_DATE(\`gl date\`, '%d-%b-%Y')) = '${year}';`
	
    }
    console.log('payload---', payload)

    var FileUploadCredentials = Fetchexecutequery();



    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          let data = response["data"];

          setIntGridData(data);

        }

      )
      .catch((error) => {
        console.error("Error in POST request:", error);
      });
  }


  const Fetchbankinfo2 = (label,date) => {
    let payload = {
 	query: `select \`Value Date\`,	\`Entry Date\`,	\`Transaction Type\`,	\`Transaction Reference\`, FORMAT(\`Debit\`,2) AS \`Debit\`,FORMAT(\`Credit\`,2) AS \`Credit\`,\`Narration\`,primary_id,match_status,match_id,close_status from txbrs.bank where gl_code = '${selectedOption.value}' and match_status = '${label}' and division = '${selectedBank.value}' and STR_TO_DATE(\`entry date\`, '%d-%b-%Y') <= STR_TO_DATE('${date}', '%d-%b-%Y') ;`
	
    }
    console.log('payload---', payload)

    var FileUploadCredentials = Fetchexecutequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          let data = response["data"];
          setExtGridData(data)
        }
      )
      .catch((error) => {
        console.error("Error in POST request:", error);
      });
  }

  const Fetchbankinfo3 = (label,date) => {

    let payload = {
 	query: `select \`vou catg\`,\`doc catg\`,\`doc no\`,\`doc date\`,\`gl date\`,\`party code\`,\`party name\`, FORMAT(\`debit amt\`,2) AS \`debit amt\`,FORMAT(\`credit amt\`,2) AS \`credit amt\`,\`narration\`,\`ref1\`,match_status,match_id,primary_id,close_status from txbrs.erp where glcd = ${selectedOption.value} and match_status = '${label}' and division = '${selectedBank.value}' and STR_TO_DATE(\`gl date\`, '%d-%b-%Y') <= STR_TO_DATE('${date}', '%d-%b-%Y');`
	
    }
    console.log('payload---', payload)

    var FileUploadCredentials = Fetchexecutequery();



    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          let data = response["data"];

          setIntGridData(data);

        }

      )
      .catch((error) => {
        console.error("Error in POST request:", error);
      });
  }


  const Fetchbankinfo_1 = (label,month,year) => {

    let payload = {
 	query: `select \`Value Date\`,	\`Entry Date\`,	\`Transaction Type\`,	\`Transaction Reference\`, FORMAT(\`Debit\`,2) AS \`Debit\`,FORMAT(\`Credit\`,2) AS \`Credit\`,\`Narration\`,primary_id,match_status,match_id,close_status,remarks from txbrs.bank where gl_code = ${selectedOption.value}  and division = '${selectedBank.value}' and MONTH(STR_TO_DATE(\`entry date\`, '%d-%b-%Y')) = '${month}' and YEAR(STR_TO_DATE(\`entry date\`, '%d-%b-%Y')) = '${year}';`	
    }
    console.log('payload---', payload)

    var FileUploadCredentials = Fetchexecutequery();
	
    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          let data = response["data"];
          setExtGridData(data);
        }

      )
      .catch((error) => {
        console.error("Error in POST request:", error);
      });
  }

  const Fetchbankinfo_ = (label,month,year) => {

    let payload = {
 	query: `select \`doc no\`, \`doc date\`, \`gl date\`, FORMAT( \`debit amt\`,2) AS \`debit amt\`,FORMAT(\`credit amt\`,2) AS \`credit amt\`, \`narration\`, \`match_status\`, \`match_id\`, primary_id,close_status from txbrs.erp where glcd = ${selectedOption.value} and division = '${selectedBank.value}' and MONTH(STR_TO_DATE(\`gl date\`, '%d-%b-%Y')) = '${month}' and YEAR(STR_TO_DATE(\`gl date\`, '%d-%b-%Y')) = '${year}';`
	
    }
    console.log('payload---', payload)

    var FileUploadCredentials = Fetchexecutequery();


    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          let data = response["data"];
          setIntGridData(data);

        }

      )
      .catch((error) => {
        console.error("Error in POST request:", error);
      });
  }


  const clickedmatchbtn = (internaldata, externaldata) => {
    const filterKey = "Closed";
    const filteredData = internaldata.filter(item => item.status === filterKey);
    const filteredData1 = externaldata.filter(item => item.status === filterKey);
    let length = filteredData.length + filteredData1.length;
    doughnutdata.push(length);

    setDoughnutData(doughnutdata);
    // let matcheddata1 = {
    //   'internal_data': filteredData,
    //   'external_data': filteredData1
    // };
    // setMatchedData(matcheddata1);
    // console.log('filteredData', matcheddata1 );
  }

  const clickedunmatchbtn = (internaldata, externaldata) => {
    const filterKey = "Open";
    const filteredData2 = internaldata.filter(item => item.status === filterKey);
    const filteredData3 = externaldata.filter(item => item.status === filterKey);
    let length = filteredData2.length + filteredData3.length;
    doughnutdata.push(length);
    setDoughnutData(doughnutdata);
    // setunmatcheddata(
    //   {
    //   'internal_data': filteredData2,
    //   'external_data': filteredData3
    //   }
    // )
    // console.log('filteredData1', filteredData2, filteredData3,length);
  }

  const clickedallbtn = (internaldata, externaldata) => {
    let length = internaldata.length + externaldata.length;
    doughnutdata.push(length);
    setDoughnutData(doughnutdata);
  }

  useEffect(() => {
    BankList();
    fetchstatuscolumntypeslist();
    console.log("selectedYear",selectedYear,selectedMonth);
    let lastDate1 = getLastDateOfMonth(selectedYear,selectedMonth);
    setlastDate(lastDate1);
    let lastDate12 = getPreviousMonthLastDate(selectedYear,selectedMonth);
    setlastDate1(lastDate12);

  }, []);

  useEffect(() => {
    getagingdashboard();
    getKpiinfo();
},[selectedOption]);


  const fetchstatuscolumntypeslist = (event) => {

    let payload = {
      'client_ids': '',
    }

    var FileUploadCredentials = getstatustypeslist();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response fetch status types list data!!!", response);
          let data = response["data"];
          let data1 = data['labels'];
          const dropdownOptions = data1.map((item) => ({ value: item.name, label: item.name }));
          setOptionslist(dropdownOptions);

        }

      )
      .catch((error) => {

        console.error("Error in POST request:", error);
      });

  }


  function getKpiinfo() {

    let query = `SELECT 
    CASE 
        WHEN DATEDIFF(CURDATE(), STR_TO_DATE(\`entry date\`, '%d-%b-%Y')) <= 30 THEN '0-30 Days'
        WHEN DATEDIFF(CURDATE(), STR_TO_DATE(\`entry date\`, '%d-%b-%Y')) BETWEEN 31 AND 60 THEN '31-60 Days'
        WHEN DATEDIFF(CURDATE(), STR_TO_DATE(\`entry date\`, '%d-%b-%Y')) BETWEEN 61 AND 90 THEN '61-90 Days'
        ELSE '90+ Days'
    END AS age_bucket,sum(Debit+Credit) as value,
    COUNT(*) AS count_in_bucket
FROM txbrs.bank
WHERE match_status = 'unmatched' and division = '${selectedBank.value}' and gl_code = '${selectedOption.value}' `
    // Add HAVING clause
    query += ` and STR_TO_DATE(\`entry date\`, '%d-%b-%Y') < STR_TO_DATE('${lastDate}', '%d-%b-%Y') GROUP BY age_bucket ORDER BY age_bucket;`;

    let payload = {
      query : query
    }
    var getProcessingLayerDataWithStatus = Fetchexecutequery();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {

          let data = response["data"];
          console.log("bank aging dashboard data!!!", data)
          let filteredData = data;
          let bucketCounts = {
                '0-30 Days': 0,
                '31-60 Days': 0,
                '61-90 Days': 0,
                '90+ Days': 0
            };

            filteredData.forEach(item => {
                // Ensure 'age_bucket' is used to populate the counts
                if (bucketCounts.hasOwnProperty(item.age_bucket)) {
                    bucketCounts[item.age_bucket] = item.value;
                }
            });

            // Convert bucketCounts object to arrays for labels and series
            const labels = headers;  // All predefined buckets
            const series = headers.map(bucket => bucketCounts[bucket]);
            console.log("bankbucket",series)
            setbankData2(series);

          // let table_data = data["data1"];
          // setExtGridData(table_data);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }


  function getagingdashboard() {
    let query = `SELECT 
    CASE 
        WHEN DATEDIFF(CURDATE(), STR_TO_DATE(\`gl date\`, '%d-%b-%Y')) <= 30 THEN '0-30 Days'
        WHEN DATEDIFF(CURDATE(), STR_TO_DATE(\`gl date\`, '%d-%b-%Y')) BETWEEN 31 AND 60 THEN '31-60 Days'
        WHEN DATEDIFF(CURDATE(), STR_TO_DATE(\`gl date\`, '%d-%b-%Y')) BETWEEN 61 AND 90 THEN '61-90 Days'
        ELSE '90+ Days'
    END AS age_bucket,sum(\`debit amt\`+\`credit amt\`) as value,
    COUNT(*) AS count_in_bucket
FROM txbrs.erp
WHERE match_status = 'unmatched' and glcd = '${selectedOption.value}' and division = '${selectedBank.value}' ` 
    
    // Add HAVING clause
    query +=` and STR_TO_DATE(\`gl date\`, '%d-%b-%Y') < STR_TO_DATE('${lastDate}', '%d-%b-%Y') GROUP BY age_bucket ORDER BY age_bucket;`;

    let payload = {
      query : query
    }


    var getProcessingLayerDataWithStatus = Fetchexecutequery();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("aging dashboard data!!!", response)
          let data = response["data"];
          let filteredData = data;
          let bucketCounts = {
                '0-30 Days': 0,
                '31-60 Days': 0,
                '61-90 Days': 0,
                '90+ Days': 0
            };

            filteredData.forEach(item => {
                // Ensure 'age_bucket' is used to populate the counts
                if (bucketCounts.hasOwnProperty(item.age_bucket)) {
                    bucketCounts[item.age_bucket] = item.value;
                }
            });

            // Convert bucketCounts object to arrays for labels and series
            const labels = headers;  // All predefined buckets
            const series = headers.map(bucket => bucketCounts[bucket]);
            console.log("bankbucket",series)
          seterpData1(series);

          let arrayLength = [];
          let datesArray = labels;
          arrayLength = datesArray && datesArray?.length;

          if (arrayLength == 3) {
            setbarwidth('40%')
          } else if (arrayLength == 2) {
            setbarwidth('30%')
          } else if (arrayLength == 1) {
            setbarwidth('10%')
          }
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }


  const fetchdonutchartdata = (date,glcode) => {
    console.log("donut2",date,glcode.value)
    let date1 = new Date(date + "-01");  // Add a day to make it a valid date
    // Get the month (in numeric format) and the year
    let month = date1.getMonth();  // getMonth() returns 0-based index (0 = January)
    let year = date1.getFullYear();
if (month === 0) {
    month = 12;  // Set month to 12 (December)
    year -= 1;   // Decrease the year by 1
}
    console.log("donut2",month,year)

    if (date,glcode) {
    let payload = {
 	query: `SELECT match_status, SUM(count) AS count
FROM (SELECT match_status, COUNT(*) AS count FROM txbrs.erp WHERE glcd = '${glcode.value}'  and division = '${selectedBank.value}' and MONTH(STR_TO_DATE(\`gl date\`, '%d-%b-%Y')) = '${month}' and YEAR(STR_TO_DATE(\`gl date\`, '%d-%b-%Y')) = '${year}' and match_status != 'Unmatched' GROUP BY match_status UNION ALL
  		SELECT match_status, COUNT(*) AS count FROM txbrs.bank WHERE gl_code = '${glcode.value}'  and division = '${selectedBank.value}' and MONTH(STR_TO_DATE(\`entry date\`, '%d-%b-%Y')) = '${month}' and YEAR(STR_TO_DATE(\`entry date\`, '%d-%b-%Y')) = '${year}' and match_status != 'Unmatched' GROUP BY match_status UNION ALL
  		SELECT match_status, COUNT(*) AS count FROM txbrs.bank WHERE gl_code = '${glcode.value}'  and division = '${selectedBank.value}' and MONTH(STR_TO_DATE(\`entry date\`, '%d-%b-%Y')) <= '${month}' and YEAR(STR_TO_DATE(\`entry date\`, '%d-%b-%Y')) <= '${year}' and match_status = 'Unmatched' GROUP BY match_status UNION ALL 
  		SELECT match_status, COUNT(*) AS count FROM txbrs.erp WHERE glcd = '${glcode.value}'  and division = '${selectedBank.value}' and MONTH(STR_TO_DATE(\`gl date\`, '%d-%b-%Y')) <= '${month}' and YEAR(STR_TO_DATE(\`gl date\`, '%d-%b-%Y')) <= '${year}' and match_status = 'Unmatched' GROUP BY match_status) AS combined
GROUP BY match_status;`
    }
      console.log('payload---', payload)

      var FileUploadCredentials = Fetchexecutequery();
      axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
  	.then(response => {      
      let countData = response.data; // Assuming the count data is directly in the response
      console.log("countData:", countData);
      const labels2 = countData.map(item => item.match_status);
      const values2 = countData.map(item => item.count);
      labels2.push('all');
      values2.push(0);
      console.log("Values:", values2,labels2);
      let label2 = labels2;
      let series2 = values2;
      setDoughnutLabel(label2);
      setDoughnutData(series2);
  })
  .catch(error => {
    console.error("Error in POST request:", error);
  });
    }};


  const fetchdonutchartdata2 = (date,glcode) => {
    console.log("donut2",date,glcode.value)
    let date1 = new Date(date + "-01");  // Add a day to make it a valid date

    // Get the month (in numeric format) and the year
    let month = date1.getMonth()+1 ;  // getMonth() returns 0-based index (0 = January)
    let year = date1.getFullYear();
    console.log("donut2",month,year)
    if (date,glcode) {
    let payload = {
 	query: `SELECT match_status, SUM(count) AS count
FROM (SELECT match_status, COUNT(*) AS count FROM txbrs.erp WHERE glcd = '${glcode.value}' and division = '${selectedBank.value}' and MONTH(STR_TO_DATE(\`gl date\`, '%d-%b-%Y')) = '${month}' and YEAR(STR_TO_DATE(\`gl date\`, '%d-%b-%Y')) = '${year}' GROUP BY match_status UNION ALL
  		SELECT match_status, COUNT(*) AS count FROM txbrs.bank WHERE gl_code = '${glcode.value}' and division = '${selectedBank.value}' and MONTH(STR_TO_DATE(\`entry date\`, '%d-%b-%Y')) = '${month}' and YEAR(STR_TO_DATE(\`entry date\`, '%d-%b-%Y')) = '${year}' GROUP BY match_status ) AS combined
GROUP BY match_status;`
    }
      console.log('payload---', payload)

      var FileUploadCredentials = Fetchexecutequery();
      axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
  	.then(response => {      
      let countData = response.data; // Assuming the count data is directly in the response
      console.log("countData:", countData);
      const labels2 = countData.map(item => item.match_status);
      const values2 = countData.map(item => item.count);
      labels2.push('all');
      values2.push(0);
      console.log("Values:", values2);
      let label2 = labels2;
      let series2 = values2;
      setDoughnutLabel2(label2);
      setDoughnutData2(series2);
  })
  .catch(error => {
    console.error("Error in POST request:", error);
  });
    }};


const handlebalClick = async () => {  // Make the function `async`
    await BalanceUpdate(selectedDate, selectedOption.value, selectedBank.value);  // Wait for BalanceUpdate to complete
    getbalanceinfo(selectedOption.value, selectedDate);  // Now call getbalanceinfo after BalanceUpdate finishes
};


const BalanceUpdate = (date, glcode, division) => {
    console.log("donut2", date, glcode);

    if (date && glcode) {  // Ensure both `date` and `glcode` are provided
        let date1 = new Date(date + "-01");  // Convert date string to Date object

        let month = date1.getMonth() + 1; // getMonth() returns 0-based index
        let year = date1.getFullYear();

        let payload = {
            "glcode": glcode,
            "month": month,
            "year": year,
            "division": division
        };
        console.log('payload---', payload);

        var FileUploadCredentials = Fetchbalupdationquery();

        axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
            .then(response => {
                console.log("bal update response", response.data);
                alert("Balance update successful!");  // Success alert
            })
            .catch(error => {
                console.error("Error in POST request:", error);
                alert("Balance update failed. Please try again.");  // Failure alert
            });
    } else {
        alert("Invalid input: date or GL code is missing.");  // Alert for missing inputs
        console.error("Invalid input: date or glcode is missing");
    }
};




  const [showDialog, setShowDialog] = useState(false);

  const handleClick = () => {
    setShowDialog(true);
    monthendbalance();
  };

  const handleclearClick = () => {
  setToleranceAmount(0); // Amount tolerance
  setDateTolerance(0);
  setFilteredintTableData([]);
  setFilteredextTableData([]);
  };


  const handleClose1 = () => {
    setShowDialog(false);
  };

const formatInLakhs = (value) => {
  const number = parseFloat(value);
  if (isNaN(number)) return 'Invalid value'; // Return an error message if the value is invalid
  const lakhs = number / 100000; // Convert to lakhs
  return `${lakhs.toFixed(2).replace(/\.00$/, '')} Lakhs`; // Format the number and remove .00 if it's a whole number
}  

  function getbalanceinfo(glcode,date) {

    let date1 = new Date(date + "-01");  // Add a day to make it a valid date
    // Get the month (in numeric format) and the year
    let month = date1.getMonth()+1;  // getMonth() returns 0-based index (0 = January)
    let year = date1.getFullYear();

    console.log("balance date",month,year,glcode)

    let payload = {
 	query: `select bank_closing_balance,erp_closing_balance,month,primary_id from txbrs.month_end_balance where gl_code= '${glcode}' and division_name = '${selectedBank.value}' and month = '${month}-${year}' ORDER BY primary_id DESC LIMIT 1;`
	
    }
    console.log('balance payload---', payload)

    var getProcessingLayerData = Fetchexecutequery();

    return axios.post(getProcessingLayerData[1], payload, getProcessingLayerData[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status with chart data----!!!", response)
          let data = response["data"];
          let arrays = data[0]["bank_closing_balance"];
          let arrays1 = data[0]["erp_closing_balance"];

          //let arrays2 = data["total"];
          console.log('data123445',data,arrays,arrays1)

          let bank_closing_balance = parseFloat(arrays);
          let erp_closing_balance = parseFloat(arrays1);
          const bank_closing_balance_1 = parseFloat(bank_closing_balance).toLocaleString('en-IN', { style: 'currency', currency: 'INR'});
	  const erp_closing_balance_1 = parseFloat(erp_closing_balance).toLocaleString('en-IN', { style: 'currency', currency: 'INR'});          
	  const variance  = parseFloat(bank_closing_balance) - parseFloat(erp_closing_balance);
	  //const bank_closing_balance_1 = bank_closing_balance;
	  //const erp_closing_balance_1 = erp_closing_balance;
          const variance_1 =  parseFloat(variance).toLocaleString('en-IN', { style: 'currency', currency: 'INR'});
          seterpbalance(erp_closing_balance_1);
          setbankbalance(bank_closing_balance_1);
          setdifference(variance_1);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }

  const changedropdown1 = (event) => {
    setdropdown1(event)
    fetchpaymenthistory(selectedOption1.value, event.value)
  }

  function handlebankSelection(event) {
    const selectedBank = event;
    setSelectedBank(selectedBank);
    BrsTypeList(event);
}

  function handleSelection(event) {
    console.log('event', event);
    const selectedValue = event;

    setSelectedOption(selectedValue);
    const filterKey = selectedValue.label;

    // Filter the data based on the specified key
    const filteredData = accnooptions.filter(item => item.value === filterKey);
    // Create a Set to track unique values
    const uniqueSet = new Set();

    // Filter the data to remove duplicates
    const filteredData1 = filteredData.filter(item => {
      const value = item.value;

      // If the value is not in the Set, add it to the Set and keep the item
      if (!uniqueSet.has(value)) {
        uniqueSet.add(value);
        return true;
      }

      return false; // Skip duplicates
    });

    console.log(filteredData1);

    console.log('filteredData', filteredData);
    getbalanceinfo(event.value,selectedDate);
    fetchmonthwisedata(event);
    fetchdonutchartdata(selectedDate,event);
    fetchdonutchartdata2(selectedDate,event);
    fetchpaymenthistory(event.label, 'Day');
    setAccountno(filteredData1);
    setOpenGridHidden(true);
    setChartHidden(true);
    setSearchHidden(true);
    getVarianceinfo1(selectedMonth,selectedYear,event)

  }

  function BankList() {
    setLoaderOpen(true);
    let payload = {
 	query: "select distinct division_name from txbrs.account_master where is_active=1 order by division_name;"
	
    }

    var getProcessingLayerList = Fetchexecutequery();
    console.log("brs", getProcessingLayerList)

    axios.post(getProcessingLayerList[1], payload, getProcessingLayerList[0])
      .then(
        response => {
          console.log("Processing customer List vendor code!!!", response)
          
          let data = response["data"];
          console.log('data', data);
          if (data) {
            let options = data.map((item) => {
    return {
      value: item.division_name, // Use the corresponding value from table_data1
      label: item.division_name // Use the corresponding label from table_data
    };
  });
            setBankoptions(options);
          }
          setLoaderOpen(false);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer List!!!", error);
          setLoaderOpen(false);
        }
      );

  }



  function BrsTypeList(event) {
    setLoaderOpen(true);
    let payload = {
 	query: `select distinct gl_code,account_number from txbrs.account_master where division_name = '${event.value}' and is_active=1 order by gl_code;`
	
    }

    var getProcessingLayerList = Fetchexecutequery();
    console.log("brs", getProcessingLayerList)

    axios.post(getProcessingLayerList[1], payload, getProcessingLayerList[0])
      .then(
        response => {
          console.log("Processing customer List vendor code!!!", response)
          
          let data = response["data"];
          console.log('data', data);
          if (data) {
            let options = data.map((item) => {
    		return {
                  value: item.gl_code, // Use the corresponding value from table_data1
                  label: item.gl_code // Use the corresponding label from table_data
                 };
            });
            let options1 = data.map((item) => {
    		return {
                  value: item.gl_code, // Use the corresponding value from table_data1
                  label: item.account_number // Use the corresponding label from table_data
                 };
            });
            setOptions(options);
            setaccnoOptions(options1);
          }
          setLoaderOpen(false);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer List!!!", error);
          setLoaderOpen(false);
        }
      );

  }

  const filterOptions = (options4, selectedption) => {
        // Implement your filtering logic here
        // Example filtering logic based on selectedOption value
        if (!selectedption) {
            return options4; // Return all options if selectedOption is null or undefined
        } else {
            const filteredOptions = options4.filter(option => option.value === selectedption.value); // Example filtering based on a property match
            return filteredOptions;
        }
    };

  function handleSelectionaccount(event) {
    const selectedValue1 = event;
    setAccountno(selectedValue1)
    const filteredOptions5 = filterOptions(options, selectedValue1); // Implement your filtering logic
    setSelectedOption(filteredOptions5[0]);
    const filterKey1 = selectedValue1.value;
    const filteredData = clientids.filter(item => item.key === filterKey1);
    // Create a Set to track unique values
    const uniqueSet = new Set();
    // Filter the data to remove duplicates
    const filteredData1 = filteredData.filter(item => {
      const value = item.value;
      // If the value is not in the Set, add it to the Set and keep the item
      if (!uniqueSet.has(value)) {
        uniqueSet.add(value);
        return true;
      }
      return false; // Skip duplicates
    });
    setclientids1(filteredData1);
    getbalanceinfo(filteredOptions5[0].value,selectedDate)
    fetchmonthwisedata(event);
    fetchdonutchartdata(selectedDate,event);
    fetchdonutchartdata2(selectedDate,event);
    fetchpaymenthistory(event.label, 'Day');
    setOpenGridHidden(true);
    setChartHidden(true);
    setSearchHidden(true);
    getVarianceinfo1(selectedMonth,selectedYear,filteredOptions5[0])

  }


  useEffect(() => {

    setSearchHidden(true);

    if (label) {
      setLoaderOpen(true); // Show loader while the API call is in progress
      getChartClickedData(label);
    }
  }, [intName, extName, label]);


  const getChartClickedData = async (selectedLabel) => {
    try {
      console.log("intNameinside", intName);
      setLoaderOpen(true); // Use the passed setLoaderOpen function
      let payload = {
        "status": selectedLabel,
        "int_name": intName,
        "ext_name": extName,
      }

      var getProcessingLayerDataWithStatus = getProcessingLayerDataWithStatusFromServer();

      const response = await axios.post(getProcessingLayerDataWithStatus[1], { params: payload }, getProcessingLayerDataWithStatus[0]);
      console.log("Processing Layer Data With Status!!!", response);
      let data = response["data"];
      if (data["Status"] === "Success") {
        console.log("data", data);
        setIntGridData(data["internal_data"]);
        setExtGridData(data["external_data"]);
        setUnMatchedHidden(false);
        setSearchHidden(false);
        setOpenGridHidden(true);
        setMatchHidden(true);
        setDuplicateHidden(true);
        setUnMatchHidden(true);
        setSelectedId(null);
        setContraHidden(true);
      }
      setLoaderOpen(false); // Use the passed setLoaderOpen function to update the state

      return response;
    } catch (error) {
      console.log("Error in Processing Layer Data With Status!!!", error);
      setLoaderOpen(false); // Use the passed setLoaderOpen function to update the state
    }
  };


  function getChartClickedDataReturn(selectedLabel) {
    let payload = {
      "status": selectedLabel,
      "int_name": intName,
      "ext_name": extName,
    }

    var getProcessingLayerDataWithStatus = getProcessingLayerDataWithStatusFromServer();

    return axios.post(getProcessingLayerDataWithStatus[1], { params: payload }, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status!!!", response)
          let data = response["data"];
          if (data["Status"] === "Success") {
            console.log("data", data);
            setIntGridData(data["internal_data"]);
            setExtGridData(data["external_data"]);
            setUnMatchedHidden(false);
            setSearchHidden(false);
            setOpenGridHidden(true);
            setMatchHidden(true);
            setDuplicateHidden(true);
            setUnMatchHidden(true);
            setSelectedId(null);
            setContraHidden(true);
          }
          return response;
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );

  }

  const intColumnDefs = React.useMemo(() => {
    if (intGridData && intGridData.length > 0) {
      const keys = Object.keys(intGridData[0]);

      const dynamicColumnDefs = [
        {
          headerCheckboxSelection: true,
          checkboxSelection: true,
          width: 50,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelectionMultiple: false,
        },
        ...keys
          .filter((key) => key !== 'id')
          .map((key) => {
            // Column definition setup
            const maxWidth = intGridData.reduce(
              (max, data) => {
                const cellContent = data[key] ? data[key].toString() : '';
                return Math.max(max, cellContent.length * 5); // Adjust the constant factor (10) as needed
              },
              100 // Set a minimum width of 100 to avoid very narrow columns
            );
            return {
              headerName: key,
              field: key.replace(/\./g, '[""]'),
              sortable: true,
              filter: true,
              resizable: true,
              width: maxWidth,
              editable: true,
              cellEditor: 'agTextCellEditor',
            };
          }),
      ];

      return dynamicColumnDefs;
    }
    return [];
  }, [intGridData]);

  let gridApi;
  let gridApiInt;

  const extColumnDefs = React.useMemo(() => {
    if (extGridData && extGridData.length > 0) {
      const keys = Object.keys(extGridData[0]);

      const dynamicColumnDefs = [
        {
          headerCheckboxSelection: true,
          checkboxSelection: true,
          width: 50,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelectionMultiple: false,
        },
        ...keys
          .filter((key) => key !== 'id')
          .map((key) => {
            // Column definition setup
            const maxWidth = extGridData.reduce(
              (max, data) => {
                const cellContent = data[key] ? data[key].toString() : '';
                return Math.max(max, cellContent.length * 5); // Adjust the constant factor (10) as needed
              },
              100 // Set a minimum width of 100 to avoid very narrow columns
            );
            return {
              headerName: key,
              field: key.replace(/\./g, '[""]'),
              sortable: true,
              filter: true,
              resizable: true,
              width: maxWidth,
              editable: true,
              cellEditor: 'agTextCellEditor',
            };
          }),
      ];

      return dynamicColumnDefs;
    }
    return [];
  }, [extGridData]);

  const onGridReady = (params) => {
    const { api } = params;
    gridApi = api;
  };

useEffect(() => {
    console.log("useEffect triggered", { extselectedDate, extselecteddebitAmount,extselectedcreditAmount,intselectedDate, intselecteddebitAmount,intselectedcreditAmount, dateTolerance });

    if (extselectedDate !== null && extselecteddebitAmount !== null && extselectedcreditAmount !== null && intselectedDate === null && intselecteddebitAmount === null && intselectedcreditAmount === null) {
        const lowerDate = new Date(extselectedDate);
        lowerDate.setDate(lowerDate.getDate() - dateTolerance);
        
        const upperDate = new Date(extselectedDate);
        upperDate.setDate(upperDate.getDate() + dateTolerance);
        
        console.log("Calculated Dates:", { lowerDate, upperDate });

        const parseDate = (dateString) => {
            if (!dateString) return null;
            const parts = dateString.split('-');
            if (parts.length !== 3) return null;

            const day = parseInt(parts[0], 10);
            const month = new Date(Date.parse(parts[1] + " 1")).getMonth(); 
            const year = 2000 + parseInt(parts[2], 10);
            return new Date(year, month, day); 
        };

        const filteredData = intGridData.filter(row => {
            const rowDate = parseDate(row['gl date']); 
            if (!rowDate) return false;
            const extselectedcreditAmount1 = parseFloat(extselectedcreditAmount );
            const extselecteddebitAmount1 = parseFloat(extselecteddebitAmount);
            const toleranceAmount1 = parseFloat(toleranceAmount); // Change to float

             

            const isDateInRange = rowDate >= lowerDate && rowDate <= upperDate;
            let isAmountInRange = false;
            let amount = 0;

            const debitAmount = parseFloat(row['debit amt']) || 0;
            const creditAmount = parseFloat(row['credit amt']) || 0;
            console.log("extselecteddebitAmount :", extselecteddebitAmount);
            // Check for debit amount if selected
            if (Number(extselecteddebitAmount)!== 0) {
                const lowerBoundcredit = extselecteddebitAmount1 - toleranceAmount;
                const upperBoundcredit = extselecteddebitAmount1 + toleranceAmount;

                console.log("credit Amount:", creditAmount);
                console.log("credit Amount Range:", lowerBoundcredit , "to", upperBoundcredit);

                isAmountInRange = creditAmount >= lowerBoundcredit && creditAmount <= upperBoundcredit;
            } 

            // Check for credit amount if selected
            if (Number(extselectedcreditAmount) !== 0) {
                const lowerBounddebit = extselectedcreditAmount1 - toleranceAmount1;
                const upperBounddebit = extselectedcreditAmount1 + toleranceAmount1;

                console.log("debit Amount:", debitAmount);
                console.log("debit Amount Range:", lowerBounddebit, "to", upperBounddebit);

                isAmountInRange = isAmountInRange || (debitAmount >= lowerBounddebit && debitAmount <= upperBounddebit);
            }      
            console.log("Filtering row:", { extselectedcreditAmount1,extselecteddebitAmount1,toleranceAmount1,  row, isDateInRange, isAmountInRange, rowDate, amount });

            return isDateInRange || isAmountInRange;
        });

        console.log("Filtered Data:", filteredData);
        setFilteredintTableData(filteredData);
        } else if (extselectedDate === null && extselecteddebitAmount === null && extselectedcreditAmount === null && intselectedDate !== null && intselecteddebitAmount !== null && intselectedcreditAmount !== null) {
        const lowerDate = new Date(intselectedDate);
        lowerDate.setDate(lowerDate.getDate() - dateTolerance);
        
        const upperDate = new Date(intselectedDate);
        upperDate.setDate(upperDate.getDate() + dateTolerance);
        
        console.log("Calculated Dates:", { lowerDate, upperDate,intselectedDate });

        const parseDate = (dateString) => {
            if (!dateString) return null;
            const parts = dateString.split('-');
            if (parts.length !== 3) return null;

            const day = parseInt(parts[0], 10);
            const month = new Date(Date.parse(parts[1] + " 1")).getMonth(); 
            const year = parseInt(parts[2], 10);
            return new Date(year, month, day); 
        };

        const filteredData = extGridData.filter(row => {
            const rowDate = parseDate(row['Entry Date']); 
            if (!rowDate) return false;
            const intselectedcreditAmount1 = parseFloat(intselectedcreditAmount );
            const intselecteddebitAmount1 = parseFloat(intselecteddebitAmount);
            const toleranceAmount1 = parseFloat(toleranceAmount); // Change to float
            console.log("rowDate,lowerDate,upperDate:",rowDate,lowerDate,upperDate);

             

            const isDateInRange = rowDate >= lowerDate && rowDate <= upperDate;
            let isAmountInRange = false;
            let amount = 0;

            const debitAmount = parseFloat(row['Debit']) || 0;
            const creditAmount = parseFloat(row['Credit']) || 0;
            console.log("intselecteddebitAmount :", intselecteddebitAmount);
            // Check for debit amount if selected
            if (Number(intselecteddebitAmount)!== 0) {
                const lowerBoundcredit = intselecteddebitAmount1 - toleranceAmount;
                const upperBoundcredit = intselecteddebitAmount1 + toleranceAmount;

                console.log("credit Amount:", creditAmount);
                console.log("credit Amount Range:", lowerBoundcredit , "to", upperBoundcredit);

                isAmountInRange = creditAmount >= lowerBoundcredit && creditAmount <= upperBoundcredit;
            } 

            // Check for credit amount if selected
            if (Number(intselectedcreditAmount) !== 0) {
                const lowerBounddebit = intselectedcreditAmount1 - toleranceAmount1;
                const upperBounddebit = intselectedcreditAmount1 + toleranceAmount1;

                console.log("debit Amount:", debitAmount);
                console.log("debit Amount Range:", lowerBounddebit, "to", upperBounddebit);

                isAmountInRange = isAmountInRange || (debitAmount >= lowerBounddebit && debitAmount <= upperBounddebit);
            }      
            console.log("Filtering row:", { intselectedcreditAmount1,intselecteddebitAmount1,toleranceAmount1,  row, isDateInRange, isAmountInRange, rowDate, amount });

            return isDateInRange || isAmountInRange;
        });


        console.log("Filtered Data:", filteredData);
        setFilteredextTableData(filteredData);
    } else {
        console.log("No filtering criteria, resetting to original data.");
        setFilteredintTableData(intGridData);
        setFilteredextTableData(extGridData); 
    }
}, [extselectedDate, extselecteddebitAmount, extselectedcreditAmount,intselectedDate, intselecteddebitAmount, intselectedcreditAmount, toleranceAmount, dateTolerance,intGridData,extGridData]);



  const OpenExtColumnDefs = React.useMemo(() => {
    if (openExtGridData?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(openExtGridData[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs1 = [
        {
          headerCheckboxSelection: true, // Add this line for the checkbox selection
          checkboxSelection: true, // Add this line for the checkbox selection
          width: 20
        },
        ...keys.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          width: 120
        })),
      ];
      // setbankcolumnnames(intColumnDefs1);
      console.log('intColumnDefs', intColumnDefs1);
      return intColumnDefs1;
    }
    return [];
  }, [openExtGridData]);





  const OpenIntColumnDefs = React.useMemo(() => {
    if (openIntGridData?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(openIntGridData[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs1 = [
        {
          headerCheckboxSelection: true, // Add this line for the checkbox selection
          checkboxSelection: true, // Add this line for the checkbox selection
          width: 20
        },
        ...keys.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          width: 120
        })),
      ];
      // setbankcolumnnames(intColumnDefs1);
      console.log('intColumnDefs', intColumnDefs1);
      return intColumnDefs1;
    }
    return [];
  }, [openIntGridData]);


  const getmatchedidrecords = (matchid, isint_ext) => {
    console.log('123467', matchid, isint_ext)
    let payload = {
 	query: `select \`vou catg\`,\`doc catg\`,\`doc no\`,\`doc date\`,\`gl date\`,\`party code\`,\`party name\`,FORMAT(\`debit amt\`,2) AS \`debit amt\`,FORMAT(\`credit amt\`,2) AS \`credit amt\`,\`narration\`,\`ref1\`,match_status,match_id,primary_id,close_status from txbrs.erp where glcd = ${selectedOption.value} and division = '${selectedBank.value}' and match_id = '${matchid}';`
	
    }
    console.log('payload---', payload)

    var getProcessingLayerData = Fetchexecutequery();
  
    axios.post(getProcessingLayerData[1], payload, getProcessingLayerData[0])
      .then(
        response => {
          console.log("Processing Layer Data 123!!!", response);
          let data = response["data"];
          setOpenIntGridData(data);
        }
      )
      .catch(
        error => {
          console.log("Error in Processing Layer Data!!!", error);
        }
      );
  
    //var getProcessingLayerDataExternal = Fetchexternaldetails();
    //console.log("url---", getProcessingLayerDataExternal[0], matchid);
    let payload2 = {
 	query: `select \`Value Date\`,\`Entry Date\`,\`Transaction Type\`,\`Transaction Reference\`,FORMAT(\`Debit\`,2) AS Debit,FORMAT(\`Credit\`,2) AS Credit,\`Narration\`, \`match_status\`, \`match_id\`, primary_id,close_status from txbrs.bank where gl_code=${selectedOption.value} and division = '${selectedBank.value}' and match_id = '${matchid}';`
	
    }
    console.log('payload---', payload)

    var getProcessingLayerDataExternal = Fetchexecutequery();

  
    axios.post(getProcessingLayerDataExternal[1], payload2, getProcessingLayerDataExternal[0])
      .then(
        response => {
          console.log("Processing Layer Data 123!!!", response);
          let data = response["data"];
  
          setOpenExtGridData(data);
	}
      )
      .catch(
        error => {
          console.log("Error in Processing Layer Data!!!", error);
        }
      );
  };
  
  const remarkscolumnnames = React.useMemo(() => {
    if (remarksdata?.length > 0) {
      // Get the column names from the first row of the JSON data
      let keys;
      if (remarksdata?.length >= 2) {
        keys = Object.keys(remarksdata[1]);
      } else {
        keys = Object.keys(remarksdata[0]);
      }

      // Create column definitions with the checkbox as the first column
      const intColumnRemarks = [

        ...keys?.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          width: 100
        })),

      ];
      setremarkscol(intColumnRemarks);

      return intColumnRemarks;
    }
    return [];
  }, [remarksdata]);


  const fetchremarksinfo = (id) => {
    let payload = {
      "primary_id": id,
    }

    var getProcessingLayerData = getremarksdata();
    console.log('payload remarks', payload);
    return axios.post(getProcessingLayerData[1], payload, getProcessingLayerData[0])
      .then(
        response => {
          console.log("Processing Layer Data get remarks json data!!!", response)
          let data = response["data"];
          let data1 = data?.remarks_data;
          console.log('data1', data1);
          setremarksdata(data1);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data!!!", error);
        }
      );

  }

  const monthendbalance = (month) => {
    console.log("balance month",month)
    let payload = {
 	query: `select * from txbrs.month_end_balance where gl_code = '${selectedOption.value}' and division_name = '${selectedBank.value}' and close_status=0 ORDER BY primary_id LIMIT 1;`
	
    }
    console.log('payload---', payload)

    var getProcessingLayerData = Fetchexecutequery();
    console.log('payload remarks', payload);
    return axios.post(getProcessingLayerData[1], payload, getProcessingLayerData[0])
      .then(
        response => {
          console.log("Processing Layer Data get remarks json data!!!", response)
          let data = response["data"];
          let data1 = data?.remarks_data;
          console.log('data1', data);
          let bankclosingbalance = data[0]["bank_closing_balance"];
          let erpclosingbalance = data[0]["erp_closing_balance"];
          let closingmonth = data[0]["month"];
          setBankclosure(bankclosingbalance );
          setErpclosure(erpclosingbalance);
          setMonthclosure(closingmonth);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data!!!", error);
        }
      );
  }

  const lockmonthendbalance = () => {
  let payload = {
    set_column: { "close_status": 1 },
    where: [{ month: monthclosure }, { gl_code: selectedOption.value }],
    schema_name: 'txbrs',
    table: 'month_end_balance'
  };
  console.log('payload---', payload);

  var getProcessingLayerData = updateclosurestatusvalue();
  console.log('payload remarks', payload);
  return axios.post(getProcessingLayerData[1], payload, getProcessingLayerData[0])
    .then(
      response => {
        console.log("Processing Layer Data get remarks json data!!!", response);
        let data = response["data"];
  console.log('payload remarks', data);

        if (data.Status === "success") {
          // Alert for success
          alert("Success!");
        } else {
          // Alert for error
          alert("Error: " + data.message);
        }
      }
    ).catch(
      error => {
        console.log("Error in Processing Layer Data!!!", error);
      }
    );
};

  
  const handleClose = () => {
    // setFormValues({ id: "", client_id: "", client_name: "", email_address: "" });
    // setShow(false);
    // setShow1(false);
    console.log('called');
    setShow2(false);
    setShow3(false);
    setOpenExtGridData([]);
    setOpenIntGridData([]);
    setcustomer_advice_location('');
    setmodelcolumnnames1([]);
    setmodelcolumnnames([]);

    setDuplicateHidden(true);
    setShow5(false);
    setShow6(false);
    setremarkscol([]);
    setremarksdata([]);
    setremarkscol1([]);
    setremarksdata1([]);
    setInternalAmount(0.00);
    setExternalAmount(0.00);

    if (agIntGridRef.current) {
      const api = agIntGridRef.current.api;
      api.deselectAll(); // This deselects all currently selected rows
    }

    if (agExtGridRef.current) {
      const api1 = agExtGridRef.current.api;
      api1.deselectAll(); // This deselects all currently selected rows
    }

    setOpenGridHidden(true);

  };

  const [intmatchid, setintmatchid] = useState([])
  const [extmatchid, setextmatchid] = useState([])

  const handleCheckboxChangeInt = (event) => {
    const selectedRow = event.api.getSelectedRows();

    const lastDictionary = selectedRow[selectedRow.length - 1];

    setOpenGridHidden(true);
    setDuplicateHidden(true);
    setShow2(false);
    let matchid = '';
    let status1 = '';
    if (selectedRow && selectedRow.length === 1 && openExtGridData.length === 0 && selectedRow[0]['match_status'] === 'Unmatched') {
     intsetSelectedDate(selectedRow[0]['gl date'])
     intsetSelecteddebitAmount(selectedRow[0]['debit amt'])
     intsetSelectedcreditAmount(selectedRow[0]['credit amt'])
     console.log("test",selectedRow.length,selectedRow[0]['match_status'])
     } else if ((selectedRow && selectedRow.length > 1 && openExtGridData.length === 0  && selectedRow[0]['match_status'] === 'Unmatched')){
      intsetSelectedDate(null);
      intsetSelecteddebitAmount(null);
      intsetSelectedcreditAmount(null);
     }

const dataset = [];  

    if (selectedRow && selectedRow.length > 0) {
      let data = selectedRow[0]['primary_id'];
      matchid = String(selectedRow[0]['match_id']);
      status1 = String(selectedRow[0]['match_status']);
      console.log(data, matchid, extGridData);
      setismatched({ value: "Closed", label: "Closed" });
      let intern_stmnt_id = String(selectedRow[0]['primary_id']);
      fetchremarksinfo(intern_stmnt_id);     
      const dataset = 1; 
      setOpenGridHidden(false);
      setChartHidden(true);
    } else {
      setmodelcolumnnames1([]);
      setmodelcolumnnames([]);
      const dataset = [];
      setintmatchid([]);
      handleClose();
      setChartHidden(false);
      setFilteredextTableData([]);
      intsetSelectedDate(null);
      intsetSelecteddebitAmount(null);
      intsetSelectedcreditAmount(null);
    }

    const filteredData = extGridData.filter(item => item.match_id === parseInt(matchid));
const cleanAmount = (val) => parseFloat(String(val).replace(/,/g, ''));

const cleanExternalAmount = cleanAmount(externalAmount);
const cleanInternalAmount = cleanAmount(internalAmount);
    if (openIntGridData?.length > 0  && cleanExternalAmount - cleanInternalAmount !== 0 && dataset !== []) {

  const selectedArray = Array.isArray(selectedRow) ? selectedRow : [selectedRow];

  const selectedIds = new Set(selectedArray.map(row => row.primary_id));

  const cleanedOpenIntGridData = openIntGridData.filter(row =>
    row.match_status !== "Unmatched" || selectedIds.has(row.primary_id)
  );

  const existingIds = new Set(cleanedOpenIntGridData.map(row => row.primary_id));

  const newRows = selectedArray.filter(
    row => !existingIds.has(row.primary_id)
  );


  if (cleanedOpenIntGridData.length > 0 && selectedRow && selectedRow.length > 0) {
    setOpenIntGridData([...cleanedOpenIntGridData, ...newRows]);
  }
    } else if (status1 === 'Unmatched') {
      console.log(selectedRow)
      setismatched({ value: "Unmatched", label: "Open" });
      setOpenIntGridData(selectedRow);
    }

    else if (selectedRow && selectedRow.length > 0) {
      setintmatchid(matchid)
      if (intmatchid && intmatchid.indexOf(matchid) !== -1) {
        console.log('if')      
      }else{
        console.log('else',matchid);
        status1 = String(selectedRow[0]['status']);
       if (status1 === 'Match') {
        setOpenExtGridData([]);
        setOpenIntGridData([]);
       }
      setChartHidden(false);
      getmatchedidrecords(matchid, 'intern');
      getgridClickedDataReturn(matchid);
      }
    }
  };

  const onGridReadyInt = (params) => {
    const { api } = params;
    gridApiInt = api;
  };


  const ClickView = () => {
    setShow2(true);
    setOpenGridHidden(false);
    setDuplicateHidden(false);
  }




  const handleCheckboxChangeExt = (event) => {
    const selectedRow = event.api.getSelectedRows();
    console.log("external selected checkbox row", selectedRow);

    const lastDictionary = selectedRow[selectedRow.length - 1];

    setOpenGridHidden(true);
    setDuplicateHidden(true);
    setShow2(false);
    let matchid = '';
    let status1 = '';
    if (selectedRow && selectedRow.length === 1 && openIntGridData.length === 0 &&selectedRow[0]['match_status'] === 'Unmatched') {
     extsetSelectedDate(selectedRow[0]['Entry Date'])
     extsetSelecteddebitAmount(selectedRow[0]['Debit'])
     extsetSelectedcreditAmount(selectedRow[0]['Credit'])
     console.log("test",selectedRow.length,selectedRow[0]['match_status'])
} else if ((selectedRow && selectedRow.length > 1 && openIntGridData.length === 0 && selectedRow[0]['match_status'] === 'Unmatched')){
      extsetSelectedDate(null);
      extsetSelecteddebitAmount(null);
      extsetSelectedcreditAmount(null);
}

const dataset = []
    if (selectedRow && selectedRow.length > 0) {
      let data = selectedRow[0]['primary_id'];
      matchid = String(selectedRow[0]['match_id']);
      status1 = String(selectedRow[0]['match_status']);
      console.log("ext selected",data, matchid, extGridData);
      setismatched({ value: "Closed", label: "Closed" });
      let extern_stmnt_id = String(selectedRow[0]['primary_id']);      
      setOpenGridHidden(false);
      const dataset = 1
      setChartHidden(true);
    } else {
      console.log('else')

      setmodelcolumnnames1([]);
      setmodelcolumnnames([]);
      setintmatchid([]);
      handleClose();
      const dataset = []
      setChartHidden(false);
      setFilteredintTableData([]);
      setOpenExtGridData([]);
      extsetSelectedDate(null);
      extsetSelecteddebitAmount(null);
      extsetSelectedcreditAmount(null);
    }

  const filteredData = intGridData.filter(item => item.Match_id === parseInt(matchid));
  const cleanAmount = (val) => parseFloat(String(val).replace(/,/g, ''));
  console.log("dataset",dataset)
  const cleanExternalAmount = cleanAmount(externalAmount);
  const cleanInternalAmount = cleanAmount(internalAmount);
  if (openExtGridData?.length > 0  && cleanExternalAmount - cleanInternalAmount !== 0 && dataset !== []) {
       const selectedArray = Array.isArray(selectedRow) ? selectedRow : [selectedRow];

  const selectedIds = new Set(selectedArray.map(row => row.primary_id));

  const cleanedOpenExtGridData = openExtGridData.filter(row =>
    row.match_status !== "Unmatched" || selectedIds.has(row.primary_id)
  );

  const existingIds = new Set(cleanedOpenExtGridData.map(row => row.primary_id));

  const newRows = selectedArray.filter(
    row => !existingIds.has(row.primary_id)
  );

  if (cleanedOpenExtGridData.length > 0 && selectedRow && selectedRow.length > 0) {
    setOpenExtGridData([...cleanedOpenExtGridData, ...newRows]);
  }
    } else if (selectedRow && selectedRow.length === 0){
    setOpenExtGridData([]);
    } else if (status1 === 'Unmatched') {
      setismatched({ value: "Unmatched", label: "Open" });
      setOpenExtGridData(selectedRow);
    }
    else if (selectedRow && selectedRow.length > 0) {
      setextmatchid(matchid)
      if (intmatchid && intmatchid.indexOf(matchid) !== -1) {
        console.log('if')
      
      }else{
        console.log('else');
        status1 = String(selectedRow[0]['status']);
       if (status1 === 'Closed') {
        setOpenExtGridData([]);
        setOpenIntGridData([]);
        setInternalAmount(0.00);
        setExternalAmount(0.00);
       }
      getmatchedidrecords(matchid, 'intern');
      getgridClickedDataReturn(matchid);
      }
    }



  };

  useEffect(() => {
    filterRowData();
  }, [selectedId]);

  const formatCurrency = (value) => {
    return value.toLocaleString('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
    });
  };


  const filterRowData = () => {
    console.log("hi", selectedId)
    if (selectedId) {
      const apiInt = agIntGridRef.current.api;
      const apiExt = agExtGridRef.current.api;

      let indexInt = 0;
      apiInt.forEachNodeAfterFilterAndSort((rowNode) => {
        const rowData = rowNode.data;
        // if (rowNode.data.matched_id === selectedId) {
        if (rowData && rowData.hasOwnProperty('matched_id') && rowData.matched_id === selectedId) {

          intMatchingRows[indexInt] = rowData;
          indexInt++;
        }
      });

      let idsum = 0;
      let icsum = 0;
      Object.values(intMatchingRows).forEach((rowData) => {
        // Check if the rowData has the 'amount' field
        if (rowData && rowData.hasOwnProperty(intDebit)) {
          // Add the amount to the sum
          idsum += rowData[intDebit];
          icsum += rowData[intCredit];
          let intAmount = idsum - icsum
          const formattedAmount = formatCurrency(intAmount);
          console.log('formattedAmount', formattedAmount);
          // setInternalAmount(formattedAmount);

          const number = 123456.78;
          const usFormatter = new Intl.NumberFormat("en-IN");
          console.log('ind', usFormatter.format(number));
        }
      });

      let indexExt = 0;
      apiExt.forEachNodeAfterFilterAndSort((rowNode) => {
        const rowData = rowNode.data;
        // if (rowNode.data.matched_id === selectedId) {
        if (rowData && rowData.hasOwnProperty('matched_id') && rowData.matched_id === selectedId) {

          extMatchingRows[indexExt] = rowData;
          indexExt++;
        }
      });

      let edsum = 0;
      let ecsum = 0;
      Object.values(extMatchingRows).forEach((rowData) => {
        // Check if the rowData has the 'amount' field
        if (rowData && rowData.hasOwnProperty(extDebit)) {
          // Add the amount to the sum
          edsum += rowData[extDebit];
          ecsum += rowData[extCredit];
          let extAmount = ecsum - edsum
          const formattedAmount1 = formatCurrency(extAmount);
          // console.log('formattedAmount1', formattedAmount1)
          // setExternalAmount(formattedAmount1);

          const number = 123456.78;
          const usFormatter = new Intl.NumberFormat("en-IN");
          console.log(usFormatter.format(number));
        }
      });

      if (intMatchingRows) {
        setOpenIntGridData(intMatchingRows);
      }
      if (extMatchingRows) {
        setOpenExtGridData(extMatchingRows);
      }
    } else {
      setOpenIntGridData([]);
      setOpenExtGridData([]);
    }
  };

  const OpenExtColumnDefs1 = React.useMemo(() => {
    if (openExtGridData.length > 0) {
      console.log("openExtGridData", openExtGridData);
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(openExtGridData[0]);

      // Create column definitions with the checkbox as the first column
      const OpenExtColumnDefs = [
        // {
        //   headerName: '',
        //   checkboxSelection: true,
        //   width: 50,
        // },
        ...keys
          .filter((key) => key !== 'id') // Filter out the "id" column
          .map((key) => {
            // Calculate the maximum content width for the current column
            const maxWidth = openExtGridData.reduce(
              (max, data) => {
                const cellContent = data[key] ? data[key].toString() : '';
                return Math.max(max, cellContent.length * 5); // Adjust the constant factor (10) as needed
              },
              100 // Set a minimum width of 100 to avoid very narrow columns
            );

            return {
              headerName: key,
              field: key.replace(/\./g, '[""]'),
              sortable: true,
              filter: true,
              resizable: true,
              width: maxWidth,
            };
          }),
      ];

      return OpenExtColumnDefs;
    }
    return [];
  }, [openExtGridData]);

  const OpenIntColumnDefs9 = React.useMemo(() => {
    if (openIntGridData.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(openIntGridData[0]);

      // Create column definitions with the checkbox as the first column
      const OpenIntColumnDefs = [
        // {
        //   headerName: '',
        //   checkboxSelection: true,
        //   width: 50,
        // },
        ...keys
          .filter((key) => key !== 'id') // Filter out the "id" column
          .map((key) => {
            // Calculate the maximum content width for the current column
            const maxWidth = openIntGridData.reduce(
              (max, data) => {
                const cellContent = data[key] ? data[key].toString() : '';
                return Math.max(max, cellContent.length * 5); // Adjust the constant factor (10) as needed
              },
              100 // Set a minimum width of 100 to avoid very narrow columns
            );

            return {
              headerName: key,
              field: key.replace(/\./g, '[""]'),
              sortable: true,
              filter: true,
              resizable: true,
              width: maxWidth,
            };
          }),
      ];

      return OpenIntColumnDefs;
    }
    return [];
  }, [openIntGridData]);
  const onFilterTextChange = (event) => {
    const { value } = event.target;
    setSearchText(value);
  };



  function getExceptiontypedata1(exception) {
    let payload = {
      'tenants_id': userCredentials["tenants_id"],
      'groups_id': userCredentials["groups_id"],
      'entities_id': userCredentials["entities_id"],
      'user_id': userCredentials["user_id"],
      'exception': exception,
      'client_id': selectedOption1.value

    }

    var getProcessingLayerDataWithStatus = getdataforcardsrecon();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          let data1 = data['outstanding_value'];
          setremarksdata(data1);
          setShow5(true);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }

  const showmodel = () => {
    setShow3(true);
  }

  const showmodelremarks = () => {
    setShow5(true);
  }


  const getFirstcarddata = () => {
    getExceptiontypedata1('Total')
  }

  const getFirstcarddata1 = () => {
    getExceptiontypedata1('Outstanding')
  }

  const getFirstcarddata2 = () => {
    getExceptiontypedata1('Over due')
  }

  const ClickAllocateButton = () => {

    let payload = {
      'tenants_id': userCredentials["tenants_id"],
      'groups_id': userCredentials["groups_id"],
      'entities_id': userCredentials["entities_id"],
      'user_id': userCredentials["user_id"],
      "intern": openIntGridData,
      "extern": openExtGridData,
      'funding_due_date': selectedDate,
      'client_name': selectedOption.label,
      'client_id': selectedOption1.value
    }

    console.log('payload', payload);
    var getProcessingLayerDataWithStatus = allocateupdatestatusvalue();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status!!!", response)

        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );

  }



  return (
    <div>
      <Grid divided style={{ paddingLeft: "10px", borderRadius: "15px", margin: '0em', marginTop: '-3.3em' }} className="mt-2 mb-2">
        <Grid.Row >
          <Grid.Column style = {{ width : "200px"}}>
            <div className="form-group1">
              <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Division</label> <br />
              <div className="reconsummary">
                <Select
                  clearable
                  options={bankoptions}
                  selection
                  size='mini'
                  onChange={handlebankSelection}
                  value={selectedBank}
                  style={{ backgroundColor: 'white' }}

                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column style = {{ width : "200px"}}>
            <div className="form-group1">
              <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Gl Code</label> <br />
              <div className="reconsummary">
                <Select
                  clearable
                  options={options}
                  selection
                  size='mini'
                  onChange={handleSelection}
                  value={selectedOption}
                  style={{ backgroundColor: 'white' }}

                />
              </div>
            </div>
          </Grid.Column>
          <Grid.Column style = {{ width : "200px"}}>
            <div className="form-group1">
              <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Account Number</label> <br />
              <div className="reconsummary">
                <Select
                  clearable
                  options={accnooptions}
                  selection
                  size='mini'
                  onChange={handleSelectionaccount}
                  value={selectedaccno}
                  style={{ backgroundColor: 'white' }}

                />
              </div>
            </div>
          </Grid.Column>
	  <Grid.Column  style={{ width: '200px' }}>
            <div className="form-group1">
              <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Month</label> <br />
                        <Input type="month" className="cardName filetype" value={selectedDate} onChange={(e) => handleDateChange(e.target.value)} id="file-upload-month" />
                </div>

         </Grid.Column>

<Grid.Column style={{ width: '250px' }}>
  {/* Book Balance Card */}
 <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Book Balance</label> <br />
  <Card className="custom-card" style={{ background: '#6d7991', marginTop: '.43em', border: '1px solid #111111', borderRadius: '10px',height: '30px' }}>
        <div>
          <Card.Description style={{ fontWeight: '500', color: 'white', fontSize: '1.2rem' }}>
            {erpbalance}
          </Card.Description>
      </div>
  </Card>
</Grid.Column>

<Grid.Column style={{ width: '250px' }}>
  {/* Bank Balance Card */}
 <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Bank Balance</label> <br />
  <Card className="custom-card" style={{ background: '#6d7991', marginTop: '.43em', border: '1px solid #111111', borderRadius: '10px',height: '30px' }}>
        <div>
          <Card.Description style={{ fontWeight: '500', color: 'white', fontSize: '1.2rem' }}>
            {bankbalance}
          </Card.Description>
        </div>
  </Card>
</Grid.Column>

<Grid.Column style={{ width: '250px' }}>
  {/* Variance Card */}
   <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Variance</label> <br />
  <Card className="custom-card" style={{ background: '#6d7991', marginTop: '.43em', border: '1px solid #111111', borderRadius: '10px',height: '30px' }}>
        <div>
          <Card.Description style={{ fontWeight: '500', color: 'white', fontSize: '1.2rem' }}>
            {difference}
          </Card.Description>
        </div>
  </Card>
</Grid.Column>


        </Grid.Row>
      </Grid>

      <Grid columns='equal' divided hidden={chartHidden}>
        <Grid.Row style={{ margin: '1.4em', marginTop: '-2.3em', marginBottom:'0px' }}>
          <Grid.Column style={{ borderRadius: '10px', marginRight: '10px', border: '1px solid #111111', backgroundColor: 'white' }} hidden={chartHidden}>

            <div className="form-group2">
              <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Previous Month</label> <br />

        <DynamicDonutChart options={chartData1.labels} series={chartData1.series} onClick={handleChartClick1} />
</div>
          </Grid.Column>
      <Grid.Column style={{ borderRadius: '10px', marginRight: '10px', border: '1px solid #111111', backgroundColor: 'white' }} hidden={chartHidden}>
            <div className="form-group2">
              <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Current Month</label> <br />
              <DynamicDonutChart options={chartData3.labels} series={chartData3.series} onClick={handleChartClick} />
	</div>
      </Grid.Column>

          <Grid.Column style={{ borderRadius: '10px', marginRight: '10px', border: '1px solid #111111', backgroundColor: 'white' }} hidden={chartHidden}>
                <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Ageing Report</label>
                <DualBarGraph query1={bankquery} query2={erpquery} headers ={headers} data1={data1} data2={data2} bar1Color="rgba(255, 0, 0, 0.5)" bar2Color="rgba(0, 255, 0, 0.5)"/>
          </Grid.Column>
          <Grid.Column style={{ borderRadius: '10px', border: '1px solid #111111', backgroundColor: 'white' }} hidden={chartHidden}>

                       <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Ageing Report</label>
                      <ReactApexChart options={chartDatanew21.options} series={chartDatanew21.series} type="line" height={250} />
               
            
          </Grid.Column> 
        </Grid.Row>
      </Grid>
      

      <div hidden={openGridHidden}>
        <div className="row">
          <div className="col-md-2 mb-3 mr-3 " style={{marginLeft:'1em'}}>
            <Select
              clearable
              options={optionslist}
              selection
              size='mini'
              onChange={handleSelectionmatched}
              value={ismatched}

            />
          </div>
          <div className="col-md-2">
            <button className="btn pr-2" style={{ height: "35px", width: "92px", marginTop: "5px", backgroundColor: "#000055", color: "#ffffff" }} onClick={ClickSaveButton}>Save</button>
          </div>
        </div>


<div>
  <Grid>
  <Grid.Row>
    <Grid.Column>
          <div className="ag-theme-alpine" style={{ height: '200px', width: '100%', marginLeft: '7px' }}>
          <h4 style={{ margin: 0 }} className="heading">Bank : Rs. {externalAmount}</h4>
                <AgGridReact columnDefs={bankcolumnnames} rowData={openExtGridData} animateRows={true}
                  // rowSelection={'multiple'}
                  pagination={true}
                  paginationPageSize={12}
                  groupSelectsChildren={true}
                  suppressAggAtRootLevel={true}
                  suppressRowClickSelection={true} 
                  rowHeight={30}/>
          </div>
    </Grid.Column>
    </Grid.Row>
    <Grid.Row>
    <Grid.Column>
          <div className="ag-theme-alpine" style={{ height: '200px', width: '100%', marginLeft: '7px' }}>
          <h4 className="heading" style={{ margin: '0' }}>Book : Rs.  {internalAmount}</h4>
                <AgGridReact columnDefs={arcolumnnames} rowData={openIntGridData} animateRows={true}
                  // rowSelection={'multiple'}
                  pagination={true}
                  paginationPageSize={12}
                  groupSelectsChildren={true}
                  suppressAggAtRootLevel={true}
                  suppressRowClickSelection={true}
                  rowHeight={30} />

          </div>
          </Grid.Column>
  </Grid.Row>
  </Grid>
        </div>
      </div>

      <div>
      
      {showDialog && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 999 // Make sure it appears above other content
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '8px',
              boxShadow: '0 0 10px rgba(0, 0, 0, 0.3)'
            }}
          >
            <h2>Month End Closing Balances</h2>

    <div style={{ marginBottom: '10px' }}>
              <label htmlFor="balance">Month:</label>
              <div style={{ display: 'inline-block', marginLeft: '10px', border: '1px solid #ccc', padding: '5px' }}>
               {monthclosure}
              </div>
            </div>
          
    <div style={{ marginBottom: '10px' }}>
              <label htmlFor="balance">ERP Closing Balance:</label>
              <div style={{ display: 'inline-block', marginLeft: '10px', border: '1px solid #ccc', padding: '5px' }}>
               {erpclosure}
              </div>
            </div>
            <div style={{ marginBottom: '10px' }}>
              <label htmlFor="otherField">Bank Closing Balance</label>
              <div style={{ display: 'inline-block', marginLeft: '10px', border: '1px solid #ccc', padding: '5px' }}>
                {bankclosure}
              </div>
              </div>
            <div>
            <button onClick={handleClose1} style={{ marginRight: '10px' }}>X</button>
            <button onClick={lockmonthendbalance}>Lock</button>
            </div>

          </div>
        </div>
      )}
    </div>




      <div hidden={unMatchedHidden} style={{ paddingTop: '1.2em' }}>
<div className="row" style={{ alignItems: 'center', marginTop: '1.2em', marginBottom: '1.2em' }}>
  {/* Search Input */}
  <div className="col-md-3" style={{ marginRight: "390px" }}>
    <div className="search-input-container" style={{ marginTop: '-1.5em' }}>
      <i className="fa fa-search search-icon"></i>
      <input
        className="search-input"
        type="text"
        placeholder="Search..."
        value={searchText}
        onChange={onFilterTextChange}
        style={{ width: '100%' }}
      />
    </div>
  </div>

  {/* Amount Tolerance Dropdown */}
  <div className="col-md">
    <label htmlFor="amount-tolerance">Amount Tolerance: </label>
    <select
      id="amount-tolerance"
      value={toleranceAmount}
      onChange={handleamounttoleranceChange}
      style={{ width: '100%' }}
    >
      {amounttoleranceValues.map((value) => (
        <option key={value} value={value}>
          {value}
        </option>
      ))}
    </select>
  </div>

  {/* Date Tolerance Dropdown */}
  <div className="col-md">
    <label htmlFor="date-tolerance">Date Tolerance: </label>
    <select
      id="date-tolerance"
      value={dateTolerance}
      onChange={handledatetoleranceChange}
      style={{ width: '100%' }}
    >
      {datetoleranceValues.map((value) => (
        <option key={value} value={value}>
          {value}
        </option>
      ))}
    </select>
  </div>

  {/* Clear Button */}
  <div className="col-md">
    <button
      className="btn pr-2"
      style={{
        height: '35px',
        width: '92px',
        marginTop: '5px',
        backgroundColor: '#000055',
        color: '#ffffff',
      }}
      onClick={handleclearClick}
    >
      Clear
    </button>
  </div>

  <div className="col-md">
    <button
      className="btn pr-2"
      style={{
        height: '35px',
        width: '92px',
        marginTop: '5px',
        backgroundColor: '#000055',
        color: '#ffffff',
      }}
      onClick={handlebalClick}
    >
      Update
    </button>
  </div>

</div>
        
        <div className="grid-container2">
          <div className="ag-theme-alpine" style={{ height: '400px', width: '100%', marginLeft: '7px' }}>
            <h3 className="heading">Bank STATEMENT</h3>
            <AgGridReact columnDefs={bankcolumnnames} rowData={filteredextTableData.length > 0 ? filteredextTableData : extGridData} animateRows={true}
              ref={agExtGridRef}
              rowSelection={'multiple'}
              pagination={true}
              paginationPageSize={12}
              groupSelectsChildren={true}
              suppressAggAtRootLevel={true}
              onRowSelected={handleCheckboxChangeExt}
              suppressRowClickSelection={true}
              quickFilterText={searchText}
              enableRangeSelection={true}
              enableRangeCopy={true}
              onGridReady={onGridReady} 
              suppressFieldDotNotation={true}
              enableCellTextSelection= {true}
              rowHeight={30}/>
          </div>
          <div className="ag-theme-alpine" style={{ height: '400px', width: '99%' }}>
            <h3 className="heading">BOOK (Ledger)</h3>
            <AgGridReact columnDefs={arcolumnnames} rowData={filteredintTableData.length > 0 ? filteredintTableData : intGridData} animateRows={true}
              ref={agIntGridRef}
              rowSelection={'multiple'}
              pagination={true}
              paginationPageSize={12}
              groupSelectsChildren={true}
              suppressAggAtRootLevel={true}
              onRowSelected={handleCheckboxChangeInt}
              suppressRowClickSelection={true}
              quickFilterText={searchText}
              onGridReady={onGridReadyInt} 
              suppressFieldDotNotation={true}
              enableCellTextSelection= {true}
              rowHeight={30}/>
          </div>
        </div>
      </div>
      <LoaderComponent loaderOpen={loaderOpen} />

      <Modal
        show={show3}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Internal Statement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="ag-theme-alpine"
            style={{ height: '300px', width: '100%' }}
          >
            <RenderGrid
              columnDefs={modelcolumnnames}
              rowData={modelcolumnnames1}
              animateRows={true}
              pagination={true}
              paginationPageSize={10}
            />
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={show5}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="ag-theme-alpine"
            style={{ height: '300px', width: '100%' }}
          >
            <RenderGrid
              columnDefs={remarkscol}
              rowData={remarksdata}
              animateRows={true}

              pagination={true}
              paginationPageSize={10}
            />
          </div>

        </Modal.Body>
        <Modal.Footer>
        
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={show6}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="ag-theme-alpine"
            style={{ height: '300px', width: '100%' }}
          >
            <RenderGrid
              columnDefs={remarkscol1}
              rowData={remarksdata1}
              animateRows={true}
              pagination={true}
              paginationPageSize={10}
            />
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ReconSummary;